"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(l, e, n, u, t, o, a) {
  try {
    var r = l[o](a),
      i = r.value;
  } catch (l) {
    return void n(l);
  }
  r.done ? e(i) : Promise.resolve(i).then(u, t);
}
function _asyncToGenerator(l) {
  return function () {
    var e = this,
      n = arguments;
    return new Promise(function (u, t) {
      var o = l.apply(e, n);
      function a(l) {
        asyncGeneratorStep(o, u, t, a, r, "next", l);
      }
      function r(l) {
        asyncGeneratorStep(o, u, t, a, r, "throw", l);
      }
      a(void 0);
    });
  };
}
function _classCallCheck(l, e) {
  if (!(l instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(l, e) {
  for (var n = 0; n < e.length; n++) {
    var u = e[n];
    u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(l, u.key, u);
  }
}
function _createClass(l, e, n) {
  return e && _defineProperties(l.prototype, e), n && _defineProperties(l, n), l;
}
var convert = require("xml-js"),
  flatten = require("flat"),
  unflatten = require("flat").unflatten,
  mapper = require("./mapper");
mapper = new mapper.Mapper();
var backendService = require("./../Backend.service"),
  sp_states = ["IN", "OH"],
  StillWaterHelper = function () {
    return _createClass(function l() {
      _classCallCheck(this, l);
    }, [{
      key: "getAllCoveragesValues",
      value: (r = _asyncToGenerator(_regeneratorRuntime.mark(function l(e, n, u, t, o) {
        var a,
          r,
          i,
          s,
          c,
          h,
          d,
          p,
          m,
          C,
          g,
          v,
          _,
          f,
          w,
          y,
          b,
          A,
          D,
          x,
          P,
          I,
          N,
          L,
          S,
          O,
          R,
          T,
          E,
          W,
          M,
          H,
          X,
          k,
          F,
          B,
          V,
          Y,
          $,
          Q,
          q,
          U,
          G,
          K,
          J,
          Z,
          j,
          z,
          ll = arguments;
        return _regeneratorRuntime.wrap(function (l) {
          for (;;) switch (l.prev = l.next) {
            case 0:
              if (a = ll.length > 5 && void 0 !== ll[5] ? ll[5] : "no", r = 0, r = "economy" == u ? 0 : "best" == u ? 1 : "expanded" == u ? 2 : 3, i = "h03", "05" != n) {
                l.next = 8;
                break;
              }
              i = "h05", l.next = 12;
              break;
            case 8:
              if ("06" != n) {
                l.next = 12;
                break;
              }
              return l.next = 11, this.getCoverageConfigBo(e, n, u, t, o);
            case 11:
              return l.abrupt("return", l.sent);
            case 12:
              return s = {
                AZ: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                CA: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                MA: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                NJ: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                NC: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                TX: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                WA: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                CO: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                OH: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                VA: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                FL: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                PA: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                OR: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                IN: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                WI: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                SC: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                KY: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                ID: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                },
                NV: {
                  h03: [100, 100, 100, 100],
                  h05: [100, 100, 100, 100]
                }
              }, c = {
                AZ: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                CA: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                MA: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                NJ: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                NC: {
                  h03: [25, 25, null, 25],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                WA: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                CO: {
                  h03: [null, 25, 50, null],
                  h05: [null, 25, 50, null]
                },
                OH: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                VA: {
                  h03: [25, 25, 50, 25],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [20, 20, 20, 25],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                OR: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                IN: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                WI: {
                  h03: [25, 25, 50, 25],
                  h05: [25, 25, 50, 25]
                },
                SC: {
                  h03: [25, 50, 50, 25],
                  h05: [25, 50, 50, 25]
                },
                KY: {
                  h03: [25, 50, 50, 25],
                  h05: [25, 50, 50, 25]
                },
                ID: {
                  h03: [25, 50, 50, 25],
                  h05: [25, 50, 50, 25]
                },
                NV: {
                  h03: [25, 50, 50, 25],
                  h05: [25, 50, 50, 25]
                }
              }, h = {
                AZ: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                CA: {
                  h03: [55, 55, 75, 55],
                  h05: [55, 55, 75, 55]
                },
                MA: {
                  h03: [50, 50, 70, 50],
                  h05: [50, 50, 70, 50]
                },
                NJ: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                NC: {
                  h03: [50, 70, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                WA: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                CO: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                OH: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                VA: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                FL: {
                  h03: [20, 50, 50, 50],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                OR: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                IN: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                WI: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                SC: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                KY: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                ID: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                },
                NV: {
                  h03: [50, 50, 75, 50],
                  h05: [50, 50, 75, 50]
                }
              }, d = {
                AZ: {
                  h03: [2500, 1500, 1e3, 2500],
                  h05: [2500, 1500, 1e3, 2500]
                },
                CA: {
                  h03: [2500, 1500, 1e3, 2500],
                  h05: [2500, 1500, 1e3, 2500]
                },
                MA: {
                  h03: [2500, 1e3, 1e3, 2500],
                  h05: [2500, 1e3, 1e3, 2500]
                },
                NJ: {
                  h03: [2500, 1500, 1e3, 2500],
                  h05: [2500, 1500, 1e3, 2500]
                },
                NC: {
                  h03: [2500, 1500, 1e3, 2500],
                  h05: [2500, 1500, 1e3, 2500]
                },
                TX: {
                  h03: [3e3, 2e3, 1e3, 2e3],
                  h05: [3e3, 2e3, 1e3, 2e3]
                },
                WA: {
                  h03: [2e3, 1e3, 1e3, 2e3],
                  h05: [2e3, 1e3, 1e3, 2e3]
                },
                CO: {
                  h03: [2500, 2e3, 1e3, 2500],
                  h05: [2500, 2e3, 1e3, 2500]
                },
                OH: {
                  h03: [2500, 1500, 1e3, 2500],
                  h05: [2500, 1500, 1e3, 2500]
                },
                VA: {
                  h03: [2500, 2e3, 1e3, 2e3],
                  h05: [2500, 2e3, 1e3, 2e3]
                },
                FL: {
                  h03: [2500, 1500, 1e3, 2500],
                  h05: [2500, 1500, 1e3, 2500]
                },
                PA: {
                  h03: [2e3, 1e3, 500, 2500],
                  h05: [2e3, 1e3, 500, 2500]
                },
                OR: {
                  h03: [2e3, 1e3, 500, 2500],
                  h05: [2e3, 1e3, 500, 2500]
                },
                IN: {
                  h03: [2e3, 1500, 1e3, 2500],
                  h05: [2e3, 1500, 1e3, 2500]
                },
                WI: {
                  h03: [2500, 2e3, 1e3, 2500],
                  h05: [2500, 2e3, 1e3, 2500]
                },
                SC: {
                  h03: [3e3, 2e3, 1e3, 2e3],
                  h05: [3e3, 2e3, 1e3, 2e3]
                },
                KY: {
                  h03: [2e3, 1500, 1e3, 2500],
                  h05: [2e3, 1500, 1e3, 2500]
                },
                ID: {
                  h03: [2500, 2e3, 1e3, 2500],
                  h05: [2500, 2e3, 1e3, 2500]
                },
                NV: {
                  h03: [2e3, 1e3, 1e3, 2500],
                  h05: [2e3, 1e3, 1e3, 2500]
                }
              }, p = {
                AZ: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                CA: {
                  h03: [40, 40, 40, 20],
                  h05: [40, 40, 40, 20]
                },
                MA: {
                  h03: [20, 40, 40, 20],
                  h05: [20, 40, 40, 20]
                },
                NJ: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                NC: {
                  h03: [20, 20, null, 20],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                WA: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                VA: {
                  h03: [40, 40, 40, 40],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [10, 10, 10, 10],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                OR: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                IN: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                WI: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                SC: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                KY: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                ID: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                },
                NV: {
                  h03: [40, 40, 40, 40],
                  h05: [40, 40, 40, 40]
                }
              }, m = {
                AZ: {
                  h03: [null, 5e3, 5e3, null],
                  h05: [null, 5e3, 5e3, null]
                },
                CA: {
                  h03: [null, 1e4, 3e4, null],
                  h05: [null, 1e4, 3e4, null]
                },
                MA: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                NJ: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                NC: {
                  h03: [null, 5e3, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, 1e4, 3e4, null],
                  h05: [null, 1e4, 3e4, null]
                },
                WA: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                CO: {
                  h03: [null, 1e4, 3e4, null],
                  h05: [null, 1e4, 3e4, null]
                },
                OH: {
                  h03: [null, 1e4, 3e4, null],
                  h05: [null, 1e4, 3e4, null]
                },
                VA: {
                  h03: [5e3, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, 5e3, 1e4, 15e3],
                  h05: [null, 5e3, 1e4, 15e3]
                },
                WI: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                SC: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                KY: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                ID: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                NV: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                }
              }, C = {
                AZ: {
                  h03: [null, null, [1e5, 1e3], null],
                  h05: [null, null, [1e5, 1e3], null]
                },
                CA: {
                  h03: [null, null, [1e5, 500], null],
                  h05: [null, null, [1e5, 500], null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, [1e5, 1e3], null],
                  h05: [null, null, [1e5, 1e3], null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, [1e5, 1e3], null],
                  h05: [null, null, [1e5, 1e3], null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, [1e5, 1e3], null],
                  h05: [null, null, [1e5, 1e3], null]
                },
                OH: {
                  h03: [null, null, [1e5, 1e3], null],
                  h05: [null, null, [1e5, 1e3], null]
                },
                VA: {
                  h03: [null, null, [1e5, 1e3], null],
                  h05: [null, null, [1e5, 1e3], null]
                },
                FL: {
                  h03: [null, null, [1e5, 1e3], null],
                  h05: [null, null, [1e5, 1e3], null]
                },
                PA: {
                  h03: [null, [1e5, 1e3], [1e5, 500], null],
                  h05: [null, [1e5, 1e3], [1e5, 500], null]
                },
                OR: {
                  h03: [null, [1e5, 1e3], [1e5, 500], null],
                  h05: [null, [1e5, 1e3], [1e5, 500], null]
                },
                IN: {
                  h03: [null, [1e5, 1e3], [1e5, 500], null],
                  h05: [null, [1e5, 1e3], [1e5, 500], null]
                },
                WI: {
                  h03: [null, [1e5, 1e3], [1e5, 500], null],
                  h05: [null, [1e5, 1e3], [1e5, 500], null]
                },
                SC: {
                  h03: [null, [1e5, 1e3], [1e5, 500], null],
                  h05: [null, [1e5, 1e3], [1e5, 500], null]
                },
                KY: {
                  h03: [null, [1e5, 1e3], [1e5, 500], null],
                  h05: [null, [1e5, 1e3], [1e5, 500], null]
                },
                ID: {
                  h03: [null, [1e5, 1e3], [1e5, 500], null],
                  h05: [null, [1e5, 1e3], [1e5, 500], null]
                },
                NV: {
                  h03: [null, null, [1e5, 1e3], null],
                  h05: [null, null, [1e5, 1e3], null]
                }
              }, g = {
                AZ: {
                  h03: [25e3, 25e3, 25e3, null],
                  h05: [25e3, 25e3, 25e3, null]
                },
                CA: {
                  h03: [null, 25e3, 25e3, null],
                  h05: [null, 25e3, 25e3, null]
                },
                MA: {
                  h03: [null, 25e3, 25e3, null],
                  h05: [null, 25e3, 25e3, null]
                },
                NJ: {
                  h03: [25e3, 25e3, 25e3, null],
                  h05: [25e3, 25e3, 25e3, null]
                },
                TX: {
                  h03: [null, null, 25e3, null],
                  h05: [null, null, 25e3, null]
                },
                WA: {
                  h03: [null, 25e3, 25e3, null],
                  h05: [null, 25e3, 25e3, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, 25e3, 25e3, null],
                  h05: [null, 25e3, 25e3, null]
                },
                VA: {
                  h03: [25e3, 25e3, 25e3, null],
                  h05: [25e3, 25e3, 25e3, null]
                },
                NC: {
                  h03: [null, 25e3, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [25e3, 25e3, 25e3, null],
                  h05: [25e3, 25e3, 25e3, null]
                },
                PA: {
                  h03: [null, null, 25e3, null],
                  h05: [null, null, 25e3, null]
                },
                OR: {
                  h03: [null, null, 25e3, null],
                  h05: [null, null, 25e3, null]
                },
                IN: {
                  h03: [null, null, 25e3, null],
                  h05: [null, null, 25e3, null]
                },
                WI: {
                  h03: [null, null, 25e3, null],
                  h05: [null, null, 25e3, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, 25e3, null],
                  h05: [null, null, 25e3, null]
                },
                ID: {
                  h03: [null, null, 25e3, null],
                  h05: [null, null, 25e3, null]
                },
                NV: {
                  h03: [null, null, 25e3, null],
                  h05: [null, null, 25e3, null]
                }
              }, v = [null, null, [2500, 1e3], null], _ = [null, [2500, 1e3], [2500, 500], null], f = [null, null, [2500, 1e3], null], this.getAge("01/01/" + t) < 50 && (v = [null, null, [1e4, 1e3], null], _ = [null, [1e4, 1e3], [1e4, 500], null], f = [null, null, [1e4, 1e3], null]), w = {
                AZ: {
                  h03: v,
                  h05: v
                },
                CA: {
                  h03: v,
                  h05: v
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: v,
                  h05: v
                },
                VA: {
                  h03: [null, null, [2500, 1e3], null],
                  h05: [null, null, [1e4, 1e3], null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, [2500, 1e3], null],
                  h05: [null, null, [1e4, 1e3], null]
                },
                CO: {
                  h03: f,
                  h05: f
                },
                OH: {
                  h03: [null, null, [2500, 1e3], null],
                  h05: [null, null, [1e4, 1e3], null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, [2500, 1e3], null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, [2500, 1e3], [2500, 500], null],
                  h05: [null, [1e4, 1e3], [1e4, 500], null]
                },
                OR: {
                  h03: [null, [2500, 1e3], [2500, 500], null],
                  h05: [null, [1e4, 1e3], [1e4, 500], null]
                },
                IN: {
                  h03: _,
                  h05: _
                },
                WI: {
                  h03: _,
                  h05: _
                },
                SC: {
                  h03: _,
                  h05: _
                },
                KY: {
                  h03: _,
                  h05: _
                },
                ID: {
                  h03: _,
                  h05: _
                },
                NV: {
                  h03: _,
                  h05: _
                }
              }, y = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [4, 4, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [5, 5, 5, null],
                  h05: [5, 5, 5, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, b = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                OR: {
                  h03: [null, 5e3, 1e4, null],
                  h05: [null, 5e3, 1e4, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, 5e3, null],
                  h05: [null, null, 5e3, null]
                },
                KY: {
                  h03: [null, null, 5e3, null],
                  h05: [null, null, 5e3, null]
                },
                ID: {
                  h03: [null, null, 5e3, null],
                  h05: [null, null, 5e3, null]
                },
                NV: {
                  h03: [null, null, 5e3, null],
                  h05: [null, null, 5e3, null]
                }
              }, A = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, D = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, x = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, P = {
                AZ: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                CO: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                OH: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                OR: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                IN: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                WI: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                SC: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                KY: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                ID: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                },
                NV: {
                  h03: [!0, !0, !0, !0],
                  h05: [!0, !0, !0, !0]
                }
              }, I = {
                AZ: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                CA: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                CO: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                OH: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                FL: {
                  h03: [25, 25, 25, 25],
                  h05: [25, 25, 25, 25]
                },
                PA: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                OR: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                IN: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                WI: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                SC: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                KY: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                ID: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                },
                NV: {
                  h03: [10, 10, 10, 10],
                  h05: [10, 10, 10, 10]
                }
              }, N = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [5e3, 5e3, 5e3, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, L = {
                AZ: {
                  h03: [!0, !0, !0, null],
                  h05: [!0, !0, !0, null]
                },
                CA: {
                  h03: [!0, !0, !0, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, S = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, !0, null],
                  h05: [null, null, !0, null]
                },
                KY: {
                  h03: [null, null, !0, null],
                  h05: [null, null, !0, null]
                },
                ID: {
                  h03: [null, null, !0, null],
                  h05: [null, null, !0, null]
                },
                NV: {
                  h03: [null, null, !0, null],
                  h05: [null, null, !0, null]
                }
              }, O = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, R = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, T = {
                AZ: {
                  h03: [null, null, [25e3, 500], null],
                  h05: [null, null, [25e3, 500], null]
                },
                CA: {
                  h03: [null, null, [25e3, 500], null],
                  h05: [null, null, [25e3, 500], null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, [25e3, 500], null],
                  h05: [null, null, [25e3, 500], null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, [25e3, 500], null],
                  h05: [null, null, [25e3, 500], null]
                },
                CO: {
                  h03: [null, null, [25e3, 500], null],
                  h05: [null, null, [25e3, 500], null]
                },
                OH: {
                  h03: [null, null, [25e3, 500], null],
                  h05: [null, null, [25e3, 500], null]
                },
                VA: {
                  h03: [null, null, [25e3, 500], null],
                  h05: [null, null, [25e3, 500], null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, [25e3, 500], null],
                  h05: [null, null, [25e3, 500], null]
                },
                PA: {
                  h03: [null, [25e3, 500], [5e4, 500], null],
                  h05: [null, [25e3, 500], [5e4, 500], null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, [25e3, 500], [5e4, 500], null],
                  h05: [null, [25e3, 500], [5e4, 500], null]
                },
                WI: {
                  h03: [null, [25e3, 500], [5e4, 500], null],
                  h05: [null, [25e3, 500], [5e4, 500], null]
                },
                SC: {
                  h03: [null, [25e3, 500], [5e4, 500], null],
                  h05: [null, [25e3, 500], [5e4, 500], null]
                },
                KY: {
                  h03: [null, [25e3, 500], [5e4, 500], null],
                  h05: [null, [25e3, 500], [5e4, 500], null]
                },
                ID: {
                  h03: [null, [25e3, 500], [5e4, 500], null],
                  h05: [null, [25e3, 500], [5e4, 500], null]
                },
                NV: {
                  h03: [null, [25e3, 500], [5e4, 500], null],
                  h05: [null, [25e3, 500], [5e4, 500], null]
                }
              }, E = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, W = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, M = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, H = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, X = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, k = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, V = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: F = ["RCC", "RCC", "RCC", "RCC"],
                  h05: B = ["RCC", "RCC", "RCC", "RCC"]
                },
                WA: {
                  h03: F,
                  h05: B
                },
                CO: {
                  h03: F,
                  h05: B
                },
                OH: {
                  h03: F,
                  h05: B
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, Q = {
                AZ: {
                  h03: Y = ["ACV", "RCC", "RCC", "RCC"],
                  h05: $ = ["ACV", "RCC", "RCC", "RCC"]
                },
                CA: {
                  h03: Y,
                  h05: $
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: Y,
                  h05: $
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: Y,
                  h05: $
                },
                WA: {
                  h03: Y,
                  h05: $
                },
                CO: {
                  h03: Y,
                  h05: $
                },
                OH: {
                  h03: Y,
                  h05: $
                },
                FL: {
                  h03: Y,
                  h05: $
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: Y,
                  h05: $
                },
                KY: {
                  h03: Y,
                  h05: $
                },
                ID: {
                  h03: Y,
                  h05: $
                },
                NV: {
                  h03: Y,
                  h05: $
                }
              }, q = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, U = {
                AZ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                FL: {
                  h03: [null, null, 2e3, null, null],
                  h05: [null, null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, G = {
                AZ: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                CA: {
                  h03: [null, null, null, null, null],
                  h05: [null, null, null, null, null]
                },
                MA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NJ: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                VA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                TX: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                CO: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OH: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                FL: {
                  h03: [null, null, 2e3, null],
                  h05: [null, null, null, null]
                },
                PA: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                OR: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                IN: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                WI: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                SC: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                KY: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                ID: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                },
                NV: {
                  h03: [null, null, null, null],
                  h05: [null, null, null, null]
                }
              }, K = [1e5, 3e5, 5e5, 1e5], J = [1e3, 2e3, 5e3, 1e3], Z = [10, 10, 10, 10], j = [null, null, !0, null], "yes" == a && (K[3] = 3e5, J[3] = 3e3), "FL" == e && (Z = [2, 2, 2, 2]), z = e, d[e] || (e = "AZ"), l.abrupt("return", {
                deductible: d[e][i][r],
                dwelling: s[e][i][r],
                other_structure: Z[r],
                personal_property: h[e][i][r],
                loss_of_use: p[e][i][r],
                liability: K[r],
                medical_payment: J[r],
                acc_rc: "economy" == u ? "ACV" : "RCC",
                inflation_guard: y[e][i][r],
                building_ordinance: I[e][i][r],
                common_construction: L[e][i][r],
                extended_replacement: c[e][i][r],
                animal_liability: S[e][i][r],
                water_backup: m[e][i][r],
                homesys_protect: C[e][i][r],
                identity_protection: g[e][i][r],
                serviceline: w[e][i][r],
                loss_asessment: b[e][i][r],
                wind_hail: A[e][i][r],
                hurricane: D[e][i][r],
                earthquake: x[e][i][r],
                mold_fungus: P[e][i][r],
                business_property: N[e][i][r],
                personal_injury: O[e][i][r],
                home_cyberbase: T[e][i][r],
                hcbpackage_databreach: E[e][i][r],
                hcbbreach_bullying: W[e][i][r],
                spp: j[r],
                state: z,
                homeType: n,
                planType: u,
                yearBuilt: t,
                brushForestError: o,
                foundation_coverage: H[e][i][r],
                limited_hurricane: X[e][i][r],
                water_damage: R[e][i][r],
                additional_Limits: k[e][i][r],
                roof_Damage_WindHail: V[e][i][r],
                contentsCov: Q[e][i][r],
                mineSubsidence: q[e][i][r],
                spec_Computer: U[e][i][r],
                dog_Liability: G[e][i][r],
                sinkHole: M[e][i][r]
              });
            case 64:
            case "end":
              return l.stop();
          }
        }, l, this);
      })), function (l, e, n, u, t) {
        return r.apply(this, arguments);
      })
    }, {
      key: "getCustomizeOptions",
      value: function (l, e) {
        var n = e.state,
          u = e.final_dwell,
          t = e.homeType,
          o = (e.planType, e.yearBuilt),
          a = {};
        if (["AZ", "CA", "MA", "NJ", "NC", "TX", "WA", "CO", "OH", "VA", "FL", "PA", "OR", "IN", "WI", "SC", "KY", "ID", "NV"].includes(n) || (n = "AZ"), "deductible" == l) {
          if ("CA" != n && "MA" != n || (a[l] = [{
            value: 250,
            text: 250
          }, {
            value: 500,
            text: 500
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 1500,
            text: 1500
          }, {
            value: 2e3,
            text: 2e3
          }, {
            value: 2500,
            text: 2500
          }, {
            value: 3e3,
            text: 3e3
          }, {
            value: 4e3,
            text: 4e3
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }]), "VA" == n && (a[l] = [{
            value: 500,
            text: 500
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 2e3,
            text: 2e3
          }, {
            value: 3e3,
            text: 3e3
          }, {
            value: 4e3,
            text: 4e3
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }]), "WA" == n && (a[l] = [{
            value: 250,
            text: 250
          }, {
            value: 500,
            text: 500
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 2e3,
            text: 2e3
          }, {
            value: 3e3,
            text: 3e3
          }, {
            value: 4e3,
            text: 4e3
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }]), "AZ" != n && "NJ" != n && "CO" != n && "OR" != n && "IN" != n && "NV" != n || (a[l] = [{
            value: 500,
            text: 500
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 2e3,
            text: 2e3
          }, {
            value: 2500,
            text: 2500
          }, {
            value: 3e3,
            text: 3e3
          }, {
            value: 4e3,
            text: 4e3
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 7500,
            text: 7500
          }, {
            value: 1e4,
            text: 1e4
          }]), "NC" == n && (a[l] = [{
            value: 500,
            text: 500
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 1500,
            text: 1500
          }, {
            value: 2e3,
            text: 2e3
          }]), "TX" == n) {
            var r = parseInt(1 * +u / 100),
              i = parseInt(1.5 * +u / 100),
              s = parseInt(2 * +u / 100),
              c = parseInt(2.5 * +u / 100),
              h = parseInt(3 * +u / 100),
              d = parseInt(4 * +u / 100),
              p = parseInt(5 * +u / 100);
            a[l] = [{
              value: 500,
              text: 500
            }, {
              value: 1e3,
              text: 1e3
            }, {
              value: 2e3,
              text: 2e3
            }, {
              value: 3e3,
              text: 3e3
            }, {
              value: 4e3,
              text: 4e3
            }, {
              value: 5e3,
              text: 5e3
            }, {
              value: r,
              text: r
            }, {
              value: i,
              text: i
            }, {
              value: s,
              text: s
            }, {
              value: c,
              text: c
            }, {
              value: h,
              text: h
            }, {
              value: d,
              text: d
            }, {
              value: p,
              text: p
            }];
          }
          "OH" != n && "ID" != n || (a[l] = [{
            value: 750,
            text: 750
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 2e3,
            text: 2e3
          }, {
            value: 2500,
            text: 2500
          }, {
            value: 3e3,
            text: 3e3
          }, {
            value: 4e3,
            text: 4e3
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 7500,
            text: 7500
          }, {
            value: 1e4,
            text: 1e4
          }], "ID" == n && (a[l].shift(), a[l].unshift({
            value: 500,
            text: 500
          }), a[l].unshift({
            value: 250,
            text: 250
          }))), "FL" == n && (a[l] = [{
            value: 500,
            text: 500
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 1500,
            text: 1500
          }, {
            value: 2500,
            text: 2500
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 7500,
            text: 7500
          }, {
            value: 1e4,
            text: 1e4
          }]), "PA" != n && "WI" != n || (a[l] = [{
            value: 500,
            text: 500
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 2e3,
            text: 2e3
          }, {
            value: 2500,
            text: 2500
          }, {
            value: 3e3,
            text: 3e3
          }, {
            value: 4e3,
            text: 4e3
          }, {
            value: 5e3,
            text: 5e3
          }]), "KY" == n && (a[l] = [{
            value: 500,
            text: 500
          }, {
            value: 750,
            text: 750
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 1500,
            text: 1500
          }, {
            value: 2e3,
            text: 2e3
          }, {
            value: 2500,
            text: 2500
          }, {
            value: 3e3,
            text: 3e3
          }, {
            value: 4e3,
            text: 4e3
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 7500,
            text: 7500
          }, {
            value: 1e4,
            text: 1e4
          }]), "SC" == n && (a[l] = [{
            value: 1e3,
            text: 1e3
          }, {
            value: 2e3,
            text: 2e3
          }, {
            value: 3e3,
            text: 3e3
          }, {
            value: 4e3,
            text: 4e3
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 7500,
            text: 7500
          }, {
            value: 1e4,
            text: 1e4
          }]);
          for (var m = 0; m < a[l].length; m++) e.deductible == a[l][m].value ? a[l][m].selected = !0 : a[l][m].selected = !1, a[l][m].text = "$" + this.numberWithCommas(a[l][m].text);
        }
        if ("personal_property" == l) {
          var C = {
            "25_RC": parseInt(25 * +u / 100),
            "25_ACV": parseInt(25 * +u / 100),
            "50_RC": parseInt(50 * +u / 100),
            "50_ACV": parseInt(50 * +u / 100),
            "55_ACV": parseInt(55 * +u / 100),
            "55_RC": parseInt(55 * +u / 100),
            "70_RC": parseInt(70 * +u / 100),
            "75_RC": parseInt(75 * +u / 100),
            "75_ACV": parseInt(75 * +u / 100)
          };
          a[l] = "CA" == n ? "03" == t ? [{
            value: "55-RCC",
            text: "$" + this.numberWithCommas(C["55_RC"]) + "-Replacement Cost",
            selected: "55" == e.personal_property && "RCC" == e.acc_rc
          }, {
            value: "55-ACV",
            text: "$" + this.numberWithCommas(C["55_ACV"]) + "-Actual Cash Value",
            selected: "55" == e.personal_property && "ACV" == e.acc_rc
          }, {
            value: "75-RCC",
            text: "$" + this.numberWithCommas(C["75_RC"]) + "-Replacement Cost",
            selected: "75" == e.personal_property
          }] : [{
            value: "55-RCC",
            text: "$" + this.numberWithCommas(C["55_RC"]) + "-Replacement Cost",
            selected: "55" == e.personal_property
          }, {
            value: "70-RCC",
            text: "$" + this.numberWithCommas(C["70_RC"]) + "-Replacement Cost",
            selected: "70" == e.personal_property
          }, {
            value: "75-RCC",
            text: "$" + this.numberWithCommas(C["75_RC"]) + "-Replacement Cost",
            selected: "75" == e.personal_property
          }] : "NJ" == n || "TX" == n || "WA" == n || "CO" == n || "OH" == n || "PA" == n || "AZ" == n || "WI" == n || "IN" == n || "KY" == n || "SC" == n || "ID" == n ? [{
            value: "50-RCC",
            text: "$" + this.numberWithCommas(C["50_RC"]) + "-Replacement Cost",
            selected: "50" == e.personal_property && "RCC" == e.acc_rc
          }, {
            value: "50-ACV",
            text: "$" + this.numberWithCommas(C["50_ACV"]) + "-Actual Cash Value",
            selected: "50" == e.personal_property && "ACV" == e.acc_rc
          }, {
            value: "75-RCC",
            text: "$" + this.numberWithCommas(C["75_RC"]) + "-Replacement Cost",
            selected: "75" == e.personal_property && "RCC" == e.acc_rc
          }, {
            value: "75-ACV",
            text: "$" + this.numberWithCommas(C["75_ACV"]) + "-Actual Cash Value",
            selected: "75" == e.personal_property && "ACV" == e.acc_rc
          }] : "FL" == n ? [{
            value: "25-RCC",
            text: "$" + this.numberWithCommas(C["25_RC"]) + "-Replacement Cost",
            selected: "25" == e.personal_property && "RCC" == e.acc_rc
          }, {
            value: "25-ACV",
            text: "$" + this.numberWithCommas(C["25_ACV"]) + "-Actual Cash Value",
            selected: "25" == e.personal_property && "ACV" == e.acc_rc
          }, {
            value: "50-RCC",
            text: "$" + this.numberWithCommas(C["50_RC"]) + "-Replacement Cost",
            selected: "50" == e.personal_property && "RCC" == e.acc_rc
          }, {
            value: "50-ACV",
            text: "$" + this.numberWithCommas(C["50_ACV"]) + "-Actual Cash Value",
            selected: "50" == e.personal_property && "ACV" == e.acc_rc
          }, {
            value: "75-RCC",
            text: "$" + this.numberWithCommas(C["75_RC"]) + "-Replacement Cost",
            selected: "75" == e.personal_property && "RCC" == e.acc_rc
          }, {
            value: "75-ACV",
            text: "$" + this.numberWithCommas(C["75_ACV"]) + "-Actual Cash Value",
            selected: "75" == e.personal_property && "ACV" == e.acc_rc
          }] : [{
            value: "50-RCC",
            text: "$" + this.numberWithCommas(C["50_RC"]) + "-Replacement Cost",
            selected: "50" == e.personal_property && "RCC" == e.acc_rc
          }, {
            value: "75-RCC",
            text: "$" + this.numberWithCommas(C["75_RC"]) + "-Replacement Cost",
            selected: "75" == e.personal_property
          }];
        }
        if ("roof_Damage_WindHail" == l && ("TX" != n && "WA" != n && "CO" != n && "OH" != n && "VA" != n && "PA" != n && "WI" != n || (a[l] = [{
          value: "RCC",
          text: "Replacement Cost",
          selected: "RCC" == e.roof_Damage_WindHail
        }, {
          value: "ACV",
          text: "Actual Cash value",
          selected: "ACV" == e.roof_Damage_WindHail
        }])), "loss_of_use" == l) {
          var g = {
            10: parseInt(10 * +u / 100),
            20: parseInt(20 * +u / 100),
            40: parseInt(40 * +u / 100)
          };
          a[l] = "FL" == n ? [{
            value: "10",
            text: "$" + this.numberWithCommas(g[10]),
            selected: "10" == e.loss_of_use
          }] : "PA" == n || "WI" == n || "IN" == n || "KY" == n ? [{
            value: "40",
            text: "$" + this.numberWithCommas(g[40]),
            selected: "40" == e.loss_of_use
          }] : [{
            value: "20",
            text: "$" + this.numberWithCommas(g[20]),
            selected: "20" == e.loss_of_use
          }, {
            value: "40",
            text: "$" + this.numberWithCommas(g[40]),
            selected: "40" == e.loss_of_use
          }];
        }
        if ("liability" == l && (a[l] = [{
          value: "100000",
          text: "$" + this.numberWithCommas("100000"),
          selected: "100000" == e.liability
        }, {
          value: "300000",
          text: "$" + this.numberWithCommas("300000"),
          selected: "300000" == e.liability
        }, {
          value: "500000",
          text: "$" + this.numberWithCommas("500000"),
          selected: "500000" == e.liability
        }]), "medical_payment" == l && (a[l] = [{
          value: "1000",
          text: "$" + this.numberWithCommas("1000"),
          selected: "1000" == e.medical_payment
        }, {
          value: "2000",
          text: "$" + this.numberWithCommas("2000"),
          selected: "2000" == e.medical_payment
        }, {
          value: "5000",
          text: "$" + this.numberWithCommas("5000"),
          selected: "5000" == e.medical_payment
        }]), "building_ordinance" == l && (a[l] = "TX" == n || "OH" == n || "WA" == n ? [{
          value: null,
          text: "No Coverage",
          selected: !e.building_ordinance
        }, {
          value: "25",
          text: "25% of Dwelling Coverage",
          selected: "25" == e.building_ordinance
        }, {
          value: "50",
          text: "50% of Dwelling Coverage",
          selected: "50" == e.building_ordinance
        }] : "FL" == n ? [{
          value: "25",
          text: "25% of Dwelling Coverage",
          selected: "25" == e.building_ordinance
        }] : [{
          value: "10",
          text: "10% of Dwelling Coverage",
          selected: "10" == e.building_ordinance
        }, {
          value: "25",
          text: "25% of Dwelling Coverage",
          selected: "25" == e.building_ordinance
        }, {
          value: "50",
          text: "50% of Dwelling Coverage",
          selected: "50" == e.building_ordinance
        }]), "extended_replacement" == l && (a[l] = "NC" == n ? [{
          value: "25",
          text: "25% of Dwelling Coverage",
          selected: !0
        }] : "WA" == n || "OH" == n || "CO" == n || "VA" == n ? [{
          value: "25",
          text: "25% of Dwelling Coverage",
          selected: "25" == e.extended_replacement
        }, {
          value: "50",
          text: "50% of Dwelling Coverage",
          selected: "50" == e.extended_replacement
        }] : "FL" == n ? [{
          value: "20",
          text: "20% of Dwelling Coverage",
          selected: "20" == e.extended_replacement
        }] : [{
          value: null,
          text: "No Coverage",
          selected: !e.extended_replacement
        }, {
          value: "25",
          text: "25% of Dwelling Coverage",
          selected: "25" == e.extended_replacement
        }, {
          value: "50",
          text: "50% of Dwelling Coverage",
          selected: "50" == e.extended_replacement
        }]), "water_backup" == l) {
          "CA" != n && "CO" != n || (e.brushForestError && "no" == e.brushForestError ? a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }, {
            value: 15e3,
            text: 15e3
          }, {
            value: 2e4,
            text: 2e4
          }, {
            value: 3e4,
            text: 3e4
          }, {
            value: 4e4,
            text: 4e4
          }, {
            value: 5e4,
            text: 5e4
          }] : a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }, {
            value: 15e3,
            text: 15e3
          }, {
            value: 2e4,
            text: 2e4
          }, {
            value: 3e4,
            text: 3e4
          }, {
            value: 4e4,
            text: 4e4
          }]), "AZ" != n && "NC" != n || (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: 5e3,
            text: 5e3
          }]), "MA" != n && "NJ" != n && "VA" != n && "SC" != n || (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }]), "TX" != n && "PA" != n && "OR" != n && "IN" != n && "WI" != n && "KY" != n && "ID" != n && "NV" != n || (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }, {
            value: 15e3,
            text: 15e3
          }, {
            value: 2e4,
            text: 2e4
          }, {
            value: 3e4,
            text: 3e4
          }, {
            value: 4e4,
            text: 4e4
          }]), "OH" == n && (a[l] = [{
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }, {
            value: 15e3,
            text: 15e3
          }, {
            value: 2e4,
            text: 2e4
          }, {
            value: 3e4,
            text: 3e4
          }, {
            value: 4e4,
            text: 4e4
          }]), "WA" == n && (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 7500,
            text: 7500
          }, {
            value: 1e4,
            text: 1e4
          }, {
            value: 15e3,
            text: 15e3
          }, {
            value: 2e4,
            text: 2e4
          }, {
            value: 3e4,
            text: 3e4
          }, {
            value: 4e4,
            text: 4e4
          }]), "FL" == n && (a[l] = [{
            value: null,
            text: "No Coverage"
          }]);
          for (var v = 0; v < a[l].length; v++) e.water_backup == a[l][v].value || null == e.water_backup || "" == e.water_backup ? a[l][v].selected = !0 : a[l][v].selected = !1, null != a[l][v].value && (a[l][v].text = "$" + this.numberWithCommas(a[l][v].text));
        }
        if ("home_cyberbase" == l && (a[l] = [{
          value: null,
          text: "No Coverage",
          selected: !e.home_cyberbase
        }, {
          value: "25000-500",
          text: "$" + this.numberWithCommas(25e3) + "($" + this.numberWithCommas(500) + " Deductible)",
          selected: !(!e.home_cyberbase || "25000" != e.home_cyberbase[0])
        }, {
          value: "50000-500",
          text: "$" + this.numberWithCommas(5e4) + "($" + this.numberWithCommas(500) + " Deductible)",
          selected: !(!e.home_cyberbase || "50000" != e.home_cyberbase[0])
        }]), "hcbpackage_databreach" == l && (a[l] = [{
          value: null,
          text: "No Coverage",
          selected: !e.hcbpackage_databreach
        }, {
          value: "25000-500",
          text: "$" + this.numberWithCommas(25e3) + "($" + this.numberWithCommas(500) + " Deductible)",
          selected: !(!e.hcbpackage_databreach || "25000" != e.hcbpackage_databreach[0])
        }, {
          value: "50000-500",
          text: "$" + this.numberWithCommas(5e4) + "($" + this.numberWithCommas(500) + " Deductible)",
          selected: !(!e.hcbpackage_databreach || "50000" != e.hcbpackage_databreach[0])
        }]), "hcbbreach_bullying" == l && (a[l] = [{
          value: null,
          text: "No Coverage",
          selected: !e.hcbbreach_bullying
        }, {
          value: "25000-500",
          text: "$" + this.numberWithCommas(25e3) + "($" + this.numberWithCommas(500) + " Deductible)",
          selected: !(!e.hcbbreach_bullying || "25000" != e.hcbbreach_bullying[0])
        }, {
          value: "50000-500",
          text: "$" + this.numberWithCommas(5e4) + "($" + this.numberWithCommas(500) + " Deductible)",
          selected: !(!e.hcbbreach_bullying || "50000" != e.hcbbreach_bullying[0])
        }]), "homesys_protect" == l && (a[l] = [{
          value: null,
          text: "No Coverage",
          selected: !e.homesys_protect
        }, {
          value: "100000-500",
          text: "$" + this.numberWithCommas(1e5) + "($" + this.numberWithCommas(500) + " Deductible)",
          selected: !(!e.homesys_protect || "500" != e.homesys_protect[1])
        }, {
          value: "100000-1000",
          text: "$" + this.numberWithCommas(1e5) + "($" + this.numberWithCommas(1e3) + " Deductible)",
          selected: !(!e.homesys_protect || "1000" != e.homesys_protect[1])
        }]), "identity_protection" == l && (a[l] = [{
          value: null,
          text: "No Coverage",
          selected: !e.identity_protection
        }, {
          value: 25e3,
          text: "$" + this.numberWithCommas(25e3),
          selected: "25000" == e.identity_protection
        }]), "serviceline" == l) {
          var _ = this.getAge("01/01/" + o);
          a[l] = _ < 50 ? [{
            value: null,
            text: "No Coverage",
            selected: !e.serviceline
          }, {
            value: "10000-500",
            text: "$" + this.numberWithCommas(1e4) + "($" + this.numberWithCommas(500) + " Deductible)",
            selected: !(!e.serviceline || "500" != e.serviceline[1])
          }, {
            value: "10000-1000",
            text: "$" + this.numberWithCommas(1e4) + "($" + this.numberWithCommas(1e3) + " Deductible)",
            selected: !(!e.serviceline || "1000" != e.serviceline[1])
          }] : [{
            value: null,
            text: "No Coverage",
            selected: !e.serviceline
          }, {
            value: "2500-500",
            text: "$" + this.numberWithCommas(2500) + "($" + this.numberWithCommas(500) + " Deductible)",
            selected: !(!e.serviceline || "500" != e.serviceline[1])
          }, {
            value: "2500-1000",
            text: "$" + this.numberWithCommas(2500) + "($" + this.numberWithCommas(1e3) + " Deductible)",
            selected: !(!e.serviceline || "1000" != e.serviceline[1])
          }];
        }
        if ("inflation_guard" == l && ("AZ" != n && "NJ" != n && "TX" != n && "WA" != n && "CO" != n && "FL" != n && "PA" != n && "OR" != n && "IN" != n && "WI" != n && "KY" != n && "ID" != n && "NV" != n || (a[l] = [{
          value: null,
          text: "No Coverage",
          selected: !e.inflation_guard
        }, {
          value: "5",
          text: "5% of Dwelling Coverage",
          selected: "5" == e.inflation_guard
        }]), "NC" == n && (a[l] = [{
          value: null,
          text: "No Coverage",
          selected: !e.inflation_guard
        }, {
          value: "4",
          text: "4% of Dwelling Coverage",
          selected: "4" == e.inflation_guard
        }, {
          value: "6",
          text: "6% of Dwelling Coverage",
          selected: "6" == e.inflation_guard
        }, {
          value: "8",
          text: "8% of Dwelling Coverage",
          selected: "8" == e.inflation_guard
        }]), "OH" == n && (a[l] = [{
          value: "5",
          text: "5% of Dwelling Coverage",
          selected: "5" == e.inflation_guard
        }])), "loss_asessment" == l) {
          a[l] = "FL" == n ? [{
            value: null,
            text: "No Coverage"
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }] : [{
            value: null,
            text: "No Coverage"
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 5e3,
            text: 5e3
          }, {
            value: 1e4,
            text: 1e4
          }, {
            value: 15e3,
            text: 15e3
          }, {
            value: 2e4,
            text: 2e4
          }, {
            value: 25e3,
            text: 25e3
          }, {
            value: 3e4,
            text: 3e4
          }, {
            value: 35e3,
            text: 35e3
          }, {
            value: 4e4,
            text: 4e4
          }, {
            value: 45e3,
            text: 45e3
          }, {
            value: 5e4,
            text: 5e4
          }];
          for (var f = 0; f < a[l].length; f++) e.loss_asessment == a[l][f].value ? a[l][f].selected = !0 : a[l][f].selected = !1, null != a[l][f].value && (a[l][f].text = "$" + this.numberWithCommas(a[l][f].text));
        }
        if ("wind_hail" == l) {
          if ("AZ" == n || "CA" == n) {
            a[l] = [];
            var w = parseInt(1 * +u / 100);
            console.log("whval 1:", w), w >= e.deductible && (a[l] = [{
              value: null,
              text: "Policy Deductible"
            }, {
              value: "1%",
              text: "1% of Dwelling Coverage"
            }, {
              value: "2%",
              text: "2% of Dwelling Coverage"
            }, {
              value: "5%",
              text: "5% of Dwelling Coverage"
            }]), w = parseInt(2 * +u / 100), console.log("whval 2:", w), w >= e.deductible && (a[l] = [{
              value: null,
              text: "Policy Deductible"
            }, {
              value: "2%",
              text: "2% of Dwelling Coverage"
            }, {
              value: "5%",
              text: "5% of Dwelling Coverage"
            }]), w = parseInt(5 * +u / 100), console.log("whval 5:", w), w >= e.deductible && (a[l] = [{
              value: null,
              text: "Policy Deductible"
            }, {
              value: "5%",
              text: "5% of Dwelling Coverage"
            }]), 0 == a[l].length && (a[l] = [{
              value: null,
              text: "Policy Deductible"
            }]);
          }
          if ("NJ" != n && "KY" != n || (a[l] = [{
            value: null,
            text: "Policy Deductible"
          }], a[l].push({
            value: "1%",
            text: "1% of Dwelling Coverage"
          }), a[l].push({
            value: "2%",
            text: "2% of Dwelling Coverage"
          }), a[l].push({
            value: "5%",
            text: "5% of Dwelling Coverage"
          }, {
            value: "7.5%",
            text: "7.5% of Dwelling Coverage"
          }, {
            value: "10%",
            text: "10% of Dwelling Coverage"
          }, {
            value: "15%",
            text: "15% of Dwelling Coverage"
          }, {
            value: "2500",
            text: "$" + this.numberWithCommas("2500")
          }, {
            value: "5000",
            text: "$" + this.numberWithCommas("5000")
          }, {
            value: "7500",
            text: "$" + this.numberWithCommas("7500")
          }, {
            value: "10000",
            text: "$" + this.numberWithCommas("10000")
          })), "ID" == n || "NV" == n) {
            var y = parseInt(1 * +u / 100);
            a[l] = [{
              value: null,
              text: "Policy Deductible"
            }], y >= 2500 && a[l].push({
              value: "1%",
              text: "1% of Dwelling Coverage"
            }), a[l].push({
              value: "2%",
              text: "2% of Dwelling Coverage"
            }, {
              value: "5%",
              text: "5% of Dwelling Coverage"
            }, {
              value: "7.5%",
              text: "7.5% of Dwelling Coverage"
            }, {
              value: "10%",
              text: "10% of Dwelling Coverage"
            }, {
              value: "15%",
              text: "15% of Dwelling Coverage"
            }, {
              value: "1500",
              text: "$" + this.numberWithCommas("1500")
            }, {
              value: "2500",
              text: "$" + this.numberWithCommas("2500")
            }, {
              value: "5000",
              text: "$" + this.numberWithCommas("5000")
            }, {
              value: "7500",
              text: "$" + this.numberWithCommas("7500")
            }, {
              value: "10000",
              text: "$" + this.numberWithCommas("10000")
            });
          }
          if ("SC" == n && (a[l] = [{
            value: null,
            text: "Policy Deductible"
          }, {
            value: "2%",
            text: "2% of Dwelling Coverage"
          }, {
            value: "5%",
            text: "5% of Dwelling Coverage"
          }, {
            value: "10%",
            text: "10% of Dwelling Coverage"
          }]), "NC" == n && (a[l] = [{
            value: null,
            text: "Policy Deductible"
          }, {
            value: "2%",
            text: "2% of Dwelling Coverage"
          }, {
            value: "5%",
            text: "5% of Dwelling Coverage"
          }, {
            value: "1000",
            text: "$" + this.numberWithCommas("1000")
          }, {
            value: "2000",
            text: "$" + this.numberWithCommas("2000")
          }, {
            value: "5000",
            text: "$" + this.numberWithCommas("5000")
          }]), "TX" == n || "WA" == n) {
            a[l] = [], a[l] = [{
              value: null,
              text: "Policy Deductible"
            }];
            var b = parseInt(1 * +u / 100);
            console.log("whval 1:", b), Number(b) >= 2500 && a[l].push({
              value: "1%",
              text: "1% of Dwelling Coverage"
            }), b = parseInt(1.5 * +u / 100), console.log("whval 1.5:", b), Number(b) >= 2500 && a[l].push({
              value: "1.5%",
              text: "1.5% of Dwelling Coverage"
            }), b = parseInt(2 * +u / 100), console.log("whval 1:", b), Number(b) >= 2500 && a[l].push({
              value: "2%",
              text: "2% of Dwelling Coverage"
            }), b = parseInt(2.5 * +u / 100), console.log("whval 2.5:", b), Number(b) >= 2500 && a[l].push({
              value: "2.5%",
              text: "2.5% of Dwelling Coverage"
            }), a[l].push({
              value: "3%",
              text: "3% of Dwelling Coverage"
            }), a[l].push({
              value: "4%",
              text: "4% of Dwelling Coverage"
            }), a[l].push({
              value: "5%",
              text: "5% of Dwelling Coverage"
            });
          }
          if ("CO" == n) {
            a[l] = [], a[l] = [{
              value: null,
              text: "Policy Deductible"
            }];
            var A = parseInt(1 * +u / 100);
            console.log("whval 1:", A), Number(A) >= 2500 && a[l].push({
              value: "1%",
              text: "1% of Dwelling Coverage"
            }), A = parseInt(2 * +u / 100), console.log("whval 1:", A), Number(A) >= 2500 && a[l].push({
              value: "2%",
              text: "2% of Dwelling Coverage"
            }), A = parseInt(5 * +u / 100), console.log("whval 1:", A), Number(A) >= 2500 && a[l].push({
              value: "5%",
              text: "5% of Dwelling Coverage"
            }), a[l] = [{
              value: "1500",
              text: "$" + this.numberWithCommas("1500")
            }, {
              value: "2000",
              text: "$" + this.numberWithCommas("2000")
            }, {
              value: "3000",
              text: "$" + this.numberWithCommas("3000")
            }, {
              value: "5000",
              text: "$" + this.numberWithCommas("5000")
            }, {
              value: "10000",
              text: "$" + this.numberWithCommas("10000")
            }];
          }
          if ("OH" == n || "IN" == n || "WI" == n) {
            a[l] = [], a[l] = [{
              value: null,
              text: "Policy Deductible"
            }, {
              value: "1500",
              text: "$" + this.numberWithCommas("1500")
            }, {
              value: "2500",
              text: "$" + this.numberWithCommas("2500")
            }, {
              value: "5000",
              text: "$" + this.numberWithCommas("5000")
            }, {
              value: "7500",
              text: "$" + this.numberWithCommas("7500")
            }, {
              value: "10000",
              text: "$" + this.numberWithCommas("10000")
            }];
            var D = parseInt(1 * +u / 100);
            console.log("whval 1:", D), Number(D) >= 2500 && a[l].push({
              value: "1%",
              text: "1% of Dwelling Coverage"
            }), D = parseInt(2 * +u / 100), console.log("whval 2:", D), Number(D) >= 2500 && a[l].push({
              value: "2%",
              text: "2% of Dwelling Coverage"
            }), D = parseInt(5 * +u / 100), console.log("whval 3:", D), Number(D) >= 2500 && a[l].push({
              value: "5%",
              text: "5% of Dwelling Coverage"
            }), "IN" !== n && (D = parseInt(7.5 * +u / 100), console.log("whval 4:", D), Number(D) >= 2500 && a[l].push({
              value: "7.5%",
              text: "7.5% of Dwelling Coverage"
            }), D = parseInt(10 * +u / 100), console.log("whval 5:", D), Number(D) >= 2500 && a[l].push({
              value: "10%",
              text: "10% of Dwelling Coverage"
            }), D = parseInt(15 * +u / 100), console.log("whval 5:", D), Number(D) >= 2500 && a[l].push({
              value: "15%",
              text: "15% of Dwelling Coverage"
            })), console.log("options[coverageType]_20", a[l]);
          }
          "VA" == n && (a[l] = [{
            value: "500",
            text: "$" + this.numberWithCommas("500")
          }, {
            value: "1000",
            text: "$" + this.numberWithCommas("1000")
          }, {
            value: "2000",
            text: "$" + this.numberWithCommas("2000")
          }, {
            value: "3000",
            text: "$" + this.numberWithCommas("3000")
          }, {
            value: "4000",
            text: "$" + this.numberWithCommas("4000")
          }, {
            value: "5000",
            text: "$" + this.numberWithCommas("5000")
          }, {
            value: "10000",
            text: "$" + this.numberWithCommas("10000")
          }]), "FL" != n && "OR" != n || (a[l] = [{
            value: null,
            text: "Policy Deductible"
          }]);
          for (var x = 0; x < a[l].length; x++) e.wind_hail == a[l][x].value ? a[l][x].selected = !0 : a[l][x].selected = !1;
        }
        if ("hurricane" == l && ("NJ" == n || "TX" == n ? a[l] = [{
          value: null,
          text: "Policy Deductible",
          selected: !e.hurricane
        }, {
          value: "2%",
          text: "2% of Dwelling Coverage",
          selected: "2%" == e.hurricane
        }, {
          value: "5%",
          text: "5% of Dwelling Coverage",
          selected: "5%" == e.hurricane
        }] : "FL" == n && (a[l] = [{
          value: null,
          text: "Policy Deductible",
          selected: !e.hurricane
        }, {
          value: "500",
          text: "500",
          selected: "500" == e.hurricane
        }, {
          value: "2%",
          text: "2% of Dwelling Coverage",
          selected: "2%" == e.hurricane
        }, {
          value: "5%",
          text: "5% of Dwelling Coverage",
          selected: "5%" == e.hurricane
        }, {
          value: "10%",
          text: "10% of Dwelling Coverage",
          selected: "10%" == e.hurricane
        }])), "earthquake" == l) {
          var P = parseInt(2 * +u / 100),
            I = parseInt(5 * +u / 100),
            N = parseInt(10 * +u / 100),
            L = parseInt(15 * +u / 100),
            S = parseInt(20 * +u / 100),
            O = parseInt(25 * +u / 100);
          "VA" != n && "AZ" != n && "TX" != n && "CO" != n && "OH" != n || (a[l] = I >= 250 ? [{
            value: null,
            text: "No Coverage"
          }, {
            value: "5",
            text: "Coverage ($" + this.numberWithCommas(I) + " Deductible)"
          }, {
            value: "10",
            text: "Coverage ($" + this.numberWithCommas(N) + " Deductible)"
          }] : [{
            value: null,
            text: "No Coverage"
          }, {
            value: "10",
            text: "Coverage ($" + this.numberWithCommas(N) + " Deductible)"
          }]), "NC" == n && (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: "10",
            text: "10% of Dwelling Coverage"
          }, {
            value: "15",
            text: "15% of Dwelling Coverage"
          }, {
            value: "20",
            text: "20% of Dwelling Coverage"
          }, {
            value: "25",
            text: "25% of Dwelling Coverage"
          }]), "WA" == n && (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: "10",
            text: "Coverage ($" + this.numberWithCommas(N) + " Deductible)"
          }, {
            value: "15",
            text: "Coverage ($" + this.numberWithCommas(L) + " Deductible)"
          }, {
            value: "20",
            text: "Coverage ($" + this.numberWithCommas(S) + " Deductible)"
          }, {
            value: "25",
            text: "Coverage ($" + this.numberWithCommas(O) + " Deductible)"
          }]), "KY" != n && "SC" != n && "NV" != n || (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: "5",
            text: "Coverage ($" + this.numberWithCommas(I) + " Deductible)"
          }, {
            value: "10",
            text: "Coverage ($" + this.numberWithCommas(N) + " Deductible)"
          }, {
            value: "15",
            text: "Coverage ($" + this.numberWithCommas(L) + " Deductible)"
          }, {
            value: "20",
            text: "Coverage ($" + this.numberWithCommas(S) + " Deductible)"
          }, {
            value: "25",
            text: "Coverage ($" + this.numberWithCommas(O) + " Deductible)"
          }]), "NJ" == n && (a[l] = [{
            value: null,
            text: "No Coverage"
          }], P >= 250 && a[l].push({
            value: "2",
            text: "2% of Dwelling Coverage"
          }), I >= 250 && a[l].push({
            value: "5",
            text: "5% of Dwelling Coverage"
          }), a[l].push({
            value: "10",
            text: "10% of Dwelling Coverage"
          }, {
            value: "15",
            text: "15% of Dwelling Coverage"
          }, {
            value: "20",
            text: "20% of Dwelling Coverage"
          }, {
            value: "25",
            text: "25% of Dwelling Coverage"
          })), "PA" != n && "IN" != n && "ID" != n || (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: "5",
            text: "5% of Dwelling Coverage"
          }, {
            value: "10",
            text: "10% of Dwelling Coverage"
          }]), "WI" == n && (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: "5",
            text: "5% of Dwelling Coverage"
          }, {
            value: "10",
            text: "10% of Dwelling Coverage"
          }, {
            value: "15",
            text: "15% of Dwelling Coverage"
          }]), "OR" == n && (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: "10",
            text: "10% of Dwelling Coverage"
          }, {
            value: "15",
            text: "15% of Dwelling Coverage"
          }]);
          for (var R = 0; R < a[l].length; R++) null == e[l] || a[l][R].value == e[l] ? a[l][R].selected = !0 : a[l][R].selected = !1;
        }
        if ("limited_hurricane" == l && "TX" == n && (a[l] = [{
          value: null,
          text: "No Coverage",
          selected: !e.limited_hurricane
        }, {
          value: "15000",
          text: "$" + this.numberWithCommas(15e3),
          selected: "15000" == e.limited_hurricane
        }]), "identity_recovery" == l && (a[l] = [{
          value: null,
          text: "No Coverage",
          selected: !e.identity_recovery
        }, {
          value: 25e3,
          text: "$" + this.numberWithCommas(25e3),
          selected: "25000" == e.identity_recovery
        }]), "other_structure" == l && "FL" == n && (a[l] = [{
          value: "1",
          text: "1% of Coverage A",
          selected: "1" == e.other_structure
        }, {
          value: "2",
          text: "2% of Coverage A",
          selected: "2" == e.other_structure
        }, {
          value: "5",
          text: "5% of Coverage A",
          selected: "5" == e.other_structure
        }, {
          value: "10",
          text: "10% of Coverage A",
          selected: "10" == e.other_structure
        }, {
          value: "15",
          text: "15% of Coverage A",
          selected: "15" == e.other_structure
        }, {
          value: "20",
          text: "20% of Coverage A",
          selected: "20" == e.other_structure
        }]), "spec_Computer" == l) {
          "FL" == n && (a[l] = [{
            value: null,
            text: "No Coverage"
          }, {
            value: 1e3,
            text: 1e3
          }, {
            value: 2e3,
            text: 2e3
          }, {
            value: 3e3,
            text: 3e3
          }, {
            value: 4e3,
            text: 4e3
          }, {
            value: 5e3,
            text: 5e3
          }]);
          for (var T = 0; T < a[l].length; T++) e.spec_Computer == a[l][T].value || null == e.spec_Computer || "" == e.spec_Computer ? a[l][T].selected = !0 : a[l][T].selected = !1, null != a[l][T].value && (a[l][T].text = "$" + this.numberWithCommas(a[l][T].text));
        }
        return console.log("options[coverageType];", a[l]), a[l];
      }
    }, {
      key: "getCoverageXML",
      value: function (l, e, n) {
        console.log("State_______", e), console.log("data_________", l);
        var u = "";
        return l.extended_replacement && (u += mapper.getSWCoverageXML({
          cdText: "SAACA",
          limitFormatType: "pct",
          limit: l.extended_replacement
        })), l.personal_property && ("06" == l.homeType ? u += mapper.getSWCoverageXML({
          cdText: "PP",
          limitFormatType: "integer",
          limit: l.personal_property,
          deductibleFormatType: "integer",
          decuctible: null == l ? void 0 : l.deductible,
          deductibleApplies: "AllPeril"
        }) : u += mapper.getSWCoverageXML({
          cdText: "PP",
          limitFormatType: "integer",
          limit: parseInt(n * +l.personal_property / 100)
        }), u += mapper.getSWCoverageXML({
          cdText: l.acc_rc
        })), l.liability && (u += mapper.getSWCoverageXML({
          cdText: "PL",
          limitFormatType: "integer",
          limit: l.liability
        })), l.medical_payment && (u += mapper.getSWCoverageXML({
          cdText: "MEDPM",
          limitFormatType: "integer",
          limit: l.medical_payment
        })), l.water_backup && (u += "FL" == e ? mapper.getSWCoverageXML({
          cdText: "SEWER"
        }) : mapper.getSWCoverageXML({
          cdText: "SEWER",
          limitFormatType: "integer",
          limit: l.water_backup
        })), l.home_cyberbase && (u += mapper.getSWCoverageXML({
          cdText: "HomeCyber",
          limitFormatType: "integer",
          limit: l.home_cyberbase[0],
          deductibleFormatType: "integer",
          decuctible: l.home_cyberbase[1]
        })), l.homesys_protect && (u += mapper.getSWCoverageXML({
          cdText: "HomeSystems",
          limitFormatType: "integer",
          limit: l.homesys_protect[0],
          deductibleFormatType: "integer",
          decuctible: l.homesys_protect[1]
        })), l.serviceline && (u += mapper.getSWCoverageXML({
          cdText: "ServiceLine",
          limitFormatType: "integer",
          limit: l.serviceline[0],
          deductibleFormatType: "integer",
          decuctible: l.serviceline[1]
        })), l.identity_protection && ("CA" != e && "MA" != e && "NC" != e && "WA" != e || (u += mapper.getSWCoverageXML({
          cdText: "FRAUD",
          limitFormatType: "integer",
          limit: l.identity_protection
        })), "AZ" != e && "NJ" != e && "VA" != e && "OH" != e && "TX" != e && "CO" != e && "FL" != e && "PA" != e && "OR" != e && "IN" != e && "WI" != e || (u += mapper.getSWCoverageXML({
          cdText: "IdentityRecovery",
          limitFormatType: "integer",
          limit: l.identity_protection
        }))), l.inflation_guard && (u += mapper.getSWCoverageXML({
          cdText: "INFGD"
        })), l.spp && (u += mapper.getSWCoverageXML({
          cdText: "SPPP"
        })), l.building_ordinance && l.building_ordinance > 10 && (u += mapper.getSWCoverageXML({
          cdText: "BOLAW",
          limitFormatType: "pct",
          limit: l.building_ordinance
        })), l.common_construction && "TX" != e && (u += mapper.getSWCoverageXML({
          cdText: "FunctionalReplCost"
        })), l.loss_asessment && (u += mapper.getSWCoverageXML({
          cdText: "LAC",
          limitFormatType: "integer",
          limit: l.loss_asessment
        })), l.mold_fungus && ("AZ" != e && "WA" != e && "CO" != e && "OH" != e && "FL" != e || (u += mapper.getSWCoverageXML({
          cdText: "MOLD"
        })), "NJ" == e && (u += mapper.getSWCoverageXML({
          cdText: "MOLDI"
        }))), l.business_property && (u += mapper.getSWCoverageXML({
          cdText: "BUSPR"
        })), l.personal_injury && (u += mapper.getSWCoverageXML({
          cdText: "PIHOM"
        })), l.water_damage && (u += mapper.getSWCoverageXML({
          cdText: "WD"
        })), l.hcbpackage_databreach && (u += mapper.getSWCoverageXML({
          cdText: "HomeCyberBreach",
          limitFormatType: "integer",
          limit: l.hcbpackage_databreach[0],
          deductibleFormatType: "integer",
          decuctible: l.hcbpackage_databreach[1]
        })), l.hcbbreach_bullying && (u += mapper.getSWCoverageXML({
          cdText: "HomeCyberBreachBully",
          limitFormatType: "integer",
          limit: l.hcbbreach_bullying[0],
          deductibleFormatType: "integer",
          decuctible: l.hcbbreach_bullying[1]
        })), l.other_structure && (u += mapper.getSWCoverageXML({
          cdText: "OS",
          limitFormatType: "integer",
          limit: parseInt(n * +l.other_structure / 100)
        })), l.loss_of_use && ("06" == l.homeType ? u += mapper.getSWCoverageXML({
          cdText: "LOU",
          limitFormatType: "integer",
          limit: +l.loss_of_use
        }) : u += mapper.getSWCoverageXML({
          cdText: "LOU",
          limitFormatType: "integer",
          limit: parseInt(n * +l.loss_of_use / 100)
        })), l.earthquake && (u += mapper.getSWCoverageXML({
          cdText: "ERQK",
          limitFormatType: "pct",
          limit: l.earthquake.replace("%", "")
        })), l.animal_liability && (u += mapper.getSWCoverageXML({
          cdText: "AnimalLiability"
        })), l.roof_Damage_WindHail && "ACV" == l.roof_Damage_WindHail && (u += mapper.getSWCoverageXML({
          cdText: "ACVRoofWindHail"
        })), l.limited_hurricane && (u += mapper.getSWCoverageXML({
          cdText: "LmtdHurricaneOutPrty"
        })), l.foundation_coverage && (u += mapper.getSWCoverageXML({
          cdText: "FND"
        })), l.spec_Computer && (u += mapper.getSWCoverageXML({
          cdText: "SpecComputerCvg",
          limitFormatType: "integer",
          limit: l.spec_Computer
        })), l.dog_Liability && (u += mapper.getSWCoverageXML({
          cdText: "DogLiability"
        })), "FL" == e && (u += mapper.getSWCoverageXML({
          cdText: "SINK"
        })), console.log("allCoverages_1111", u), u;
      }
    }, {
      key: "getDeductibleXML",
      value: function (l) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "wind_hail",
          n = "";
        return l.wind_hail && "wind_hail" == e && l.brushForestError && "no" == l.brushForestError && (l.wind_hail.includes("%") ? n += "<Deductible>\n                                    <FormatPct>".concat(l.wind_hail.replace("%", ""), "</FormatPct>\n                                    <DeductibleAppliesToCd>WindHail</DeductibleAppliesToCd>\n                                </Deductible>") : n += "<Deductible>\n                                    <FormatInteger>".concat(l.wind_hail, "</FormatInteger>\n                                    <DeductibleAppliesToCd>WindHail</DeductibleAppliesToCd>\n                                </Deductible>")), l.hurricane && "hurricane" == e && (n += "<Deductible>\n                                <FormatPct>".concat(l.hurricane.replace("%", ""), "</FormatPct>\n                                <DeductibleAppliesToCd>HURR</DeductibleAppliesToCd>\n                            </Deductible>")), n;
      }
    }, {
      key: "getRecommendedSWQuote",
      value: (a = _asyncToGenerator(_regeneratorRuntime.mark(function l(e, n, u, t, o, a, r) {
        var i, s, c, h, d, p, m, C, g;
        return _regeneratorRuntime.wrap(function (l) {
          for (;;) switch (l.prev = l.next) {
            case 0:
              return l.next = 2, this.getAllCoveragesValues(e.state, n, u, e.yearbuilt, r, e.stateMinimum);
            case 2:
              return i = l.sent, "plan_4" == u && "yes" == e.stateMinimum && (+e.replacementCost > 2e5 && (i.liability = 5e5), "Finished" == e.propertyDetails.foundationType ? i.water_backup = 15e3 : i.water_backup = 1e4), i.quoteId = t, s = this.getCoverageXML(i, e.state, e.coverage), console.log("allCoverages_1", s), console.log("commonCoverages0_1", i), c = this.swQuoteDiscountXML(e, i), console.log("sw_discounts_01", c), h = mapper.mapdata("", "stillWater", e), c.marriedStatus && "" != c.marriedStatus && (h = (h = h.replace("MARITALSTATUS_PLACEHOLDER", c.marriedStatus)).replace("SPOUSEDETAILS_PLACEHOLDER", c.spouseDetails)), c.construction && "" != c.construction && (h = h.replace("CONSTRUCTION_PLACEHOLDER", c.construction), console.log("swQuoteDiscountXML_construction", c.construction)), c.bldgProtection && "" != c.bldgProtection && (h = h.replace("BLDGPROTECTION_PLACEHOLDER", c.bldgProtection)), c.home24 && "" != c.home24 && (s += c.home24), c.stillwater_HailResistiveRoof && "" != c.stillwater_HailResistiveRoof && (s += c.stillwater_HailResistiveRoof), c.stillwater_RoofCoveringInstallCertificate && "" != c.stillwater_RoofCoveringInstallCertificate && (s += c.stillwater_RoofCoveringInstallCertificate), c.stillwater_BurglarAlarmCertTX && "" != c.stillwater_BurglarAlarmCertTX && (s += c.stillwater_BurglarAlarmCertTX), c.stillwater_DeadBoltLockingDeviceCertTX && "" != c.stillwater_DeadBoltLockingDeviceCertTX && (s += c.stillwater_DeadBoltLockingDeviceCertTX), c.stillwater_ConstructionPermit && "" != c.stillwater_ConstructionPermit && (s += c.stillwater_ConstructionPermit), s += this.getQuoteKnockoutXML(e), console.log("allCoverages001", s), e.ssn && "" != e.ssn && (d = "<TaxIdentity>\n                    <TaxIdTypeCd>SSN</TaxIdTypeCd>\n                    <TaxId>".concat(e.ssn, "</TaxId>\n                    </TaxIdentity>"), h = h.replace("TAX_PLACEHOLDER", d), console.log("TaxIdTypeCdTaxIdTypeCdTaxIdTypeCd", h)), a && "" != a && (h = h.replace("POLICYNUMBER_PLACEHOLDER", this.getPolicyNumberXML(a))), h = h.replace("DEDUCTIBLE_PLACEHOLDER", i.deductible), e.propertyDetails.purchase_date && "" != e.propertyDetails.purchase_date && (p = new Date(e.propertyDetails.purchase_date), m = p.getFullYear(), h = (h = h.replace("PURCHASEYEAR_PLACEHOLDER", "<PurchaseDt>" + e.propertyDetails.purchase_date + "</PurchaseDt>")).replace("YEAROCCUPANCY_PLACEHOLDER", "<YearOccupancy>" + m + "</YearOccupancy>")), e.priorAddress && (h = h.replace("PREVADDRESS_PLACEHOLDER", this.getPrevAddressXMLfromCommonInput(e.priorAddress))), h = (h = (h = (h = h.replace("BLDGIMPROVEMENTS_PLACEHOLDER", this.getBldgImprovementXml(e))).replace("DWELLINSPECTIONVALUATION_PLACEHOLDER", this.getDwellInspection(e))).replace("COMMUNICATION_PLACEHOLDER", this.getCommunicationXml(e))).replace("POLICYTYPE_PLACEHOLDER", n), C = "06" == n ? "CD" : "DW", h = (h = (h = (h = (h = h.replace("RESIDENCETYPE_PLACEHOLDER", C)).replace("COVERAGES_PLACEHOLDER", s)).replace("WINDHAIL_PLACEHOLDER", this.getDeductibleXML(i, "wind_hail"))).replace("HURRICANE_PLACEHOLDER", this.getDeductibleXML(i, "hurricane"))).replaceAll("RQUID_PLACEHOLDER", e.sw_rquid || "00000000-0000-0000-0000-000000000000"), h = mapper.cleanSWXML(h), console.log("xmlInputString_2", h), l.next = 42, this.invokeSWApi(h, o);
            case 42:
              return g = l.sent, l.abrupt("return", {
                swOutput: g,
                commonCoverages: i
              });
            case 44:
            case "end":
              return l.stop();
          }
        }, l, this);
      })), function (l, e, n, u, t, o, r) {
        return a.apply(this, arguments);
      })
    }, {
      key: "getCustomizedSWQuote",
      value: (o = _asyncToGenerator(_regeneratorRuntime.mark(function l(e, n, u, t, o) {
        var a, r, i, s, c, h, d, p, m;
        return _regeneratorRuntime.wrap(function (l) {
          for (;;) switch (l.prev = l.next) {
            case 0:
              if (console.log("commonCoverages_0001", n), a = this.getCoverageXML(n, e.state, e.coverage), r = this.swQuoteDiscountXML(e, n), i = mapper.mapdata("", "stillWater", e), r.marriedStatus && "" != r.marriedStatus && (i = (i = i.replace("MARITALSTATUS_PLACEHOLDER", r.marriedStatus)).replace("SPOUSEDETAILS_PLACEHOLDER", r.spouseDetails)), r.construction && "" != r.construction && (i = i.replace("CONSTRUCTION_PLACEHOLDER", r.construction)), r.bldgProtection && "" != r.bldgProtection && (i = i.replace("BLDGPROTECTION_PLACEHOLDER", r.bldgProtection)), r.home24 && "" != r.home24 && (a += r.home24), r.stillwater_HailResistiveRoof && "" != r.stillwater_HailResistiveRoof && (a += r.stillwater_HailResistiveRoof), r.stillwater_RoofCoveringInstallCertificate && "" != r.stillwater_RoofCoveringInstallCertificate && (a += r.stillwater_RoofCoveringInstallCertificate), r.stillwater_BurglarAlarmCertTX && "" != r.stillwater_BurglarAlarmCertTX && (a += r.stillwater_BurglarAlarmCertTX), r.stillwater_DeadBoltLockingDeviceCertTX && "" != r.stillwater_DeadBoltLockingDeviceCertTX && (a += r.stillwater_DeadBoltLockingDeviceCertTX), r.stillwater_ConstructionPermit && "" != r.stillwater_ConstructionPermit && (a += r.stillwater_ConstructionPermit), a += this.getQuoteKnockoutXML(e), s = "", e.sw_spp && e.sw_spp.length > 0) for (c = 0; c < e.sw_spp.length; c++) s += mapper.getSWSPPXML({
                amount: e.sw_spp[c].spp_value,
                spp_id: e.sw_spp[c].spp_id,
                desc: e.sw_spp[c].spp_desc
              });
              return o && "" != o && (i = i.replace("POLICYNUMBER_PLACEHOLDER", this.getPolicyNumberXML(o))), i = (i = (i = i.replace("DEDUCTIBLE_PLACEHOLDER", n.deductible)).replace("DWELLINSPECTIONVALUATION_PLACEHOLDER", this.getDwellInspection(e))).replace("COMMUNICATION_PLACEHOLDER", this.getCommunicationXml(e)), e.propertyDetails.purchase_date && "" != e.propertyDetails.purchase_date && (h = new Date(e.propertyDetails.purchase_date), d = h.getFullYear(), i = (i = i.replace("PURCHASEYEAR_PLACEHOLDER", "<PurchaseDt>" + e.propertyDetails.purchase_date + "</PurchaseDt>")).replace("YEAROCCUPANCY_PLACEHOLDER", "<YearOccupancy>" + d + "</YearOccupancy>")), e.priorAddress && (i = i.replace("PREVADDRESS_PLACEHOLDER", this.getPrevAddressXMLfromCommonInput(e.priorAddress))), i = (i = i.replace("BLDGIMPROVEMENTS_PLACEHOLDER", this.getBldgImprovementXml(e))).replace("POLICYTYPE_PLACEHOLDER", n.homeType), p = "06" == n.homeType ? "CD" : "DW", i = (i = (i = (i = (i = (i = i.replace("RESIDENCETYPE_PLACEHOLDER", p)).replace("COVERAGES_PLACEHOLDER", a)).replace("WINDHAIL_PLACEHOLDER", this.getDeductibleXML(n, "wind_hail"))).replace("HURRICANE_PLACEHOLDER", this.getDeductibleXML(n, "hurricane"))).replace("SPP_PLACEHOLDER", s)).replaceAll("RQUID_PLACEHOLDER", e.sw_rquid || "00000000-0000-0000-0000-000000000000"), i = mapper.cleanSWXML(i), console.log("xmlInputString_1", i), l.next = 36, this.invokeSWApi(i, t);
            case 36:
              return m = l.sent, l.abrupt("return", {
                swOutput: m,
                commonCoverages: n
              });
            case 38:
            case "end":
              return l.stop();
          }
        }, l, this);
      })), function (l, e, n, u, t) {
        return o.apply(this, arguments);
      })
    }, {
      key: "checkSWKnockout",
      value: (t = _asyncToGenerator(_regeneratorRuntime.mark(function l(e, n, u, t, o, a) {
        var r, i, s, c, h, d, p, m, C, g, v, _;
        return _regeneratorRuntime.wrap(function (l) {
          for (;;) switch (l.prev = l.next) {
            case 0:
              if (r = this.getCoverageXML(n, e.state, e.coverage), i = this.swQuoteDiscountXML(e, n), console.log("sw_discounts__10", i), s = mapper.mapdata("", "stillWater", e), i.marriedStatus && "" != i.marriedStatus && (s = (s = s.replace("MARITALSTATUS_PLACEHOLDER", i.marriedStatus)).replace("SPOUSEDETAILS_PLACEHOLDER", i.spouseDetails)), i.home24 && "" != i.home24 && (r += i.home24), c = "", e.sw_spp && e.sw_spp.length > 0) for (h = 0; h < e.sw_spp.length; h++) c += mapper.getSWSPPXML({
                amount: e.sw_spp[h].spp_value,
                spp_id: e.sw_spp[h].spp_id,
                desc: e.sw_spp[h].spp_desc
              });
              return r += this.getQuoteKnockoutXML(e), d = [], new (require("../UrlMapper.service").UrlMapper)(), (p = this.swAppKnockoutXMLTrack2(e, t, n))["4pt8"] && "" != p["4pt8"] && (r += p["4pt8"], d.push({
                screen: "4pt8",
                flag: "YES"
              })), p["4pt11"] && "" != p["4pt11"] && (s = s.replace("LOSS_PLACEHOLDER", p["4pt11"]), d.push({
                screen: "4pt11",
                flag: "NO"
              })), p["4pt12"] && "" != p["4pt12"] && (r += p["4pt12"], d.push({
                screen: "4pt12",
                flag: "YES"
              })), p["4pt13"] && "" != p["4pt13"] && (r += p["4pt13"], d.push({
                screen: "4pt13",
                flag: "NO"
              })), p["4pt14"] && "" != p["4pt14"] && (r += p["4pt14"], d.push({
                screen: "4pt14",
                flag: "NO"
              })), e.sprinklerId && "" != e.sprinklerId && (s = s.replace("BLDGPROTECTION_PLACEHOLDER", i.bldgProtection)), p["4pt16"] && "" != p["4pt16"] ? (s = s.replace("CONSTRUCTION_PLACEHOLDER", p["4pt16"]), d.push({
                screen: "4pt16",
                flag: "YES"
              })) : s = s.replace("CONSTRUCTION_PLACEHOLDER", i.construction), p["4pt17"] && "" != p["4pt17"] && (r += p["4pt17"], d.push({
                screen: "4pt17",
                flag: "NO"
              })), p["4pt19"] && "" != p["4pt19"] && (r += p["4pt19"], d.push({
                screen: "4pt19",
                flag: "NO"
              })), p["4pt20"] && "" != p["4pt20"] && (s = s.replace("</Dwell>", p["4pt20"] + "</Dwell>"), d.push({
                screen: "4pt20",
                flag: "NO"
              })), p["4pt22"] && "" != p["4pt22"] ? (s = s.replace("BLDGPROTECTION_PLACEHOLDER", p["4pt22"]), d.push({
                screen: "4pt22",
                flag: "YES"
              })) : s = s.replace("BLDGPROTECTION_PLACEHOLDER", i.bldgProtection), p["4pt10"] && "" != p["4pt10"] && (s = s.replace("OCEAN_PLACEHOLDER", p["4pt10"]), d.push({
                screen: "4pt10",
                flag: "NO"
              })), p["4pt24"] && "" != p["4pt24"] && (r += p["4pt24"], d.push({
                screen: "4pt24",
                flag: "NO"
              })), p["4pt7EffectiveDate"] && "" != p["4pt7EffectiveDate"] && (s = s.replace("EFFECTIVEDATE_PLACEHOLDER", p["4pt7EffectiveDate"])), p["4pt7OtherPolicy"] && "" != p["4pt7OtherPolicy"] && (s = s.replace("OTHERPOLICY_PLACEHOLDER", p["4pt7OtherPolicy"])), m = (m = t.sw_homePurchasetDate.split("/")[1]) || "2000", e.propertyDetails.purchase_date && "" != e.propertyDetails.purchase_date && (C = new Date(e.propertyDetails.purchase_date), m = C.getFullYear()), console.log("stillwater PURCHASEYEAR:", m), s = s.replace("PREVADDRESS_PLACEHOLDER", this.getPrevAddressXML(t, m)), a && "" != a && (s = s.replace("POLICYNUMBER_PLACEHOLDER", this.getPolicyNumberXML(a))), i.stillwater_HailResistiveRoof && "" != i.stillwater_HailResistiveRoof && (r += i.stillwater_HailResistiveRoof), i.stillwater_RoofCoveringInstallCertificate && "" != i.stillwater_RoofCoveringInstallCertificate && (r += i.stillwater_RoofCoveringInstallCertificate), i.stillwater_BurglarAlarmCertTX && "" != i.stillwater_BurglarAlarmCertTX && (r += i.stillwater_BurglarAlarmCertTX), i.stillwater_DeadBoltLockingDeviceCertTX && "" != i.stillwater_DeadBoltLockingDeviceCertTX && (r += i.stillwater_DeadBoltLockingDeviceCertTX), i.stillwater_ConstructionPermit && "" != i.stillwater_ConstructionPermit && (r += i.stillwater_ConstructionPermit), "CA" != e.state && e.credit_consent && (r += this.getSSNConsentXml()), e.ssn && "" != e.ssn && (g = "<TaxIdentity>\n                    <TaxIdTypeCd>SSN</TaxIdTypeCd>\n                    <TaxId>".concat(e.ssn, "</TaxId>\n                    </TaxIdentity>"), s = s.replace("TAX_PLACEHOLDER", g)), s = (s = (s = (s = (s = (s = (s = s.replace("COMMUNICATION_PLACEHOLDER", this.getCommunicationXml(e))).replace("PURCHASEYEAR_PLACEHOLDER", "<PurchaseDt>" + m + "</PurchaseDt>")).replace("BLDGIMPROVEMENTS_PLACEHOLDER", this.getBldgImprovementXml(e))).replace("YEAROCCUPANCY_PLACEHOLDER", "<YearOccupancy>" + m + "</YearOccupancy>")).replace("DEDUCTIBLE_PLACEHOLDER", n.deductible)).replace("DWELLINSPECTIONVALUATION_PLACEHOLDER", this.getDwellInspection(e))).replace("POLICYTYPE_PLACEHOLDER", n.homeType), v = "06" == n.homeType ? "CD" : "DW", s = (s = (s = (s = (s = (s = s.replace("RESIDENCETYPE_PLACEHOLDER", v)).replace("COVERAGES_PLACEHOLDER", r)).replace("WINDHAIL_PLACEHOLDER", this.getDeductibleXML(n, "wind_hail"))).replace("HURRICANE_PLACEHOLDER", this.getDeductibleXML(n, "hurricane"))).replace("SPP_PLACEHOLDER", c)).replaceAll("RQUID_PLACEHOLDER", e.sw_rquid || "00000000-0000-0000-0000-000000000000"), s = mapper.cleanSWXML(s), console.log("xmlInputString_test1", s), l.next = 61, this.invokeSWApi(s, u + "-stillwater");
            case 61:
              return _ = l.sent, l.abrupt("return", {
                swOutput: _,
                commonCoverages: n,
                counterOfferFlag: d
              });
            case 63:
            case "end":
              return l.stop();
          }
        }, l, this);
      })), function (l, e, n, u, o, a) {
        return t.apply(this, arguments);
      })
    }, {
      key: "invokeSWApi",
      value: (u = _asyncToGenerator(_regeneratorRuntime.mark(function l(e) {
        var n,
          u,
          t,
          o,
          a,
          r,
          i = arguments;
        return _regeneratorRuntime.wrap(function (l) {
          for (;;) switch (l.prev = l.next) {
            case 0:
              if (t = i.length > 1 && void 0 !== i[1] ? i[1] : "12345Sw", o = i.length > 2 && void 0 !== i[2] ? i[2] : "quote", a = "", e = mapper.cleanSWXML(e), "quote" != o) {
                l.next = 10;
                break;
              }
              return l.next = 7, backendService.getQuotesFromStillWater({
                xmlInputString: e
              }, t);
            case 7:
              a = l.sent, l.next = 13;
              break;
            case 10:
              return l.next = 12, backendService.getBindFromStillWater({
                xmlInputString: e
              }, t);
            case 12:
              a = l.sent;
            case 13:
              return a = JSON.parse((null === (n = a) || void 0 === n ? void 0 : n.Payload) || "{}"), a = null !== (u = a.body) && void 0 !== u && u.output[0] && a.body.output[0].output ? a.body.output[0].output : "", r = convert.xml2json(a, {
                compact: !0,
                spaces: 4
              }), r = JSON.parse(r), l.abrupt("return", r);
            case 18:
            case "end":
              return l.stop();
          }
        }, l);
      })), function (l) {
        return u.apply(this, arguments);
      })
    }, {
      key: "swQuoteDiscountXML_old",
      value: function (l, e) {
        var n = "",
          u = "",
          t = "",
          o = "",
          a = "",
          r = "",
          i = "",
          s = "",
          c = "",
          h = "";
        if (l.sw_discounts.includes(4965) || "M" == l.maritalStatus) {
          n += "<PersonInfo>";
          var d = this.formatDate(l.dob);
          console.log("swQuoteDiscountXML commonInput['dob']:", l.dob, "this.formatDate(commonInput['dob'])", d), l.dob.includes("NaN") || l.dob.includes("nan") || d.includes("NaN") || d.includes("nan") || "" == d ? console.log("Dob not added") : n += " <BirthDt>".concat(d, "</BirthDt>");
        } else {
          n += "<PersonInfo>";
          var p = this.formatDate(l.dob);
          console.log("swQuoteDiscountXML commonInput['dob']:", l.dob, "this.formatDate(commonInput['dob'])", p), l.dob.includes("NaN") || l.dob.includes("nan") || p.includes("NaN") || p.includes("nan") ? console.log("Dob not added") : n += " <BirthDt>".concat(p, "</BirthDt>");
        }
        if (n += " <MaritalStatusCd>".concat(l.maritalStatus ? l.maritalStatus : "M", "</MaritalStatusCd>\n                                </PersonInfo>"), ("M" == l.maritalStatus || "C" == l.maritalStatus) && l.partnerSpouseDetails || l.isCoApplicant && l.coApplicantDetails) {
          var m = "M" == l.maritalStatus || "C" == l.maritalStatus ? l.partnerSpouseDetails : l.isCoApplicant ? l.coApplicantDetails : {
            dob: ""
          };
          if (m.hasOwnProperty("dob") && "" != m.dob && "" != m.firstName && "" != m.lastName) {
            var C = this.formatDate(m.dob),
              g = "" != m.middleName ? "<OtherGivenName>".concat(m.middleName, "</OtherGivenName>") : "";
            u = "<InsuredOrPrincipal>\n                    <GeneralPartyInfo>\n                        <NameInfo>\n                        <PersonName>\n                            <Surname>".concat(m.lastName, "</Surname>\n                            <GivenName>").concat(m.firstName, " </GivenName>\n                            ").concat(g, "\n                        </PersonName>\n                        </NameInfo>\n                    </GeneralPartyInfo>\n                    <InsuredOrPrincipalInfo>\n                        <InsuredOrPrincipalRoleCd>AI</InsuredOrPrincipalRoleCd>\n                        <PersonInfo>\n                            <BirthDt>").concat(C, "</BirthDt>\n                        </PersonInfo>\n                    </InsuredOrPrincipalInfo>\n                </InsuredOrPrincipal>");
          }
        }
        return t += "<Construction>\n                                <YearBuilt>".concat(l.yearbuilt, "</YearBuilt>"), l.propertyDetails.foundationType ? t += " <FoundationCd>".concat(l.propertyDetails.foundationType, "</FoundationCd>\n            \x3c!--<NumStories>").concat(l.propertyDetails.stories, "</NumStories>--\x3e\n            \x3c!--<RoofingMaterial>\n                    <RoofMaterialCd>").concat(l.propertyDetails.roof_type, "</RoofMaterialCd>\n                </RoofingMaterial>--\x3e\n                                    <ElectricalPanelCd>CIRC</ElectricalPanelCd>") : t += "\n            \x3c!--<NumStories>".concat(l.propertyDetails.stories, "</NumStories>--\x3e\n            \x3c!--<RoofingMaterial>\n                    <RoofMaterialCd>").concat(l.propertyDetails.roof_type, "</RoofMaterialCd>\n                </RoofingMaterial>--\x3e\n                                    <ElectricalPanelCd>CIRC</ElectricalPanelCd>"), l.sw_discounts.includes(61) && l.ca_builder && ("" != l.ca_builder || null != l.ca_builder || null != l.ca_builder) && (t += "<com.stillwater_AccreditedBuilder>\n            <com.stillwater_BuilderNumber>".concat(l.ca_builder, "</com.stillwater_BuilderNumber>\n                                </com.stillwater_AccreditedBuilder > ")), l.sw_discounts.includes(1205) && l.roofShapeId && ("" != l.roofShapeId || null != l.roofShapeId || null != l.roofShapeId) && (t += " <RoofGeometryTypeCd>".concat(l.roofShapeId, "</RoofGeometryTypeCd>\n            ")), t += "</Construction > ", (l.sw_discounts.includes(4301) || l.sw_discounts.includes(4200) || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305) || "05" == e.homeType || l.sw_discounts.includes(2e3)) && (o += "<BldgProtection>", o += "<FireExtinguisherInd>1</FireExtinguisherInd>"), l.sw_discounts.includes(4305) && (o += "<ProtectionDeviceBurglarCd>CN</ProtectionDeviceBurglarCd>"), (l.sw_discounts.includes(4255) || l.sw_discounts.includes(4301)) && (o += "<ProtectionDeviceFireCd>CN</ProtectionDeviceFireCd>"), (l.sw_discounts.includes(2e3) || l.sw_discounts.includes(4200) || "05" == e.homeType || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305)) && (o += "<ProtectionDeviceSmokeCd>DE</ProtectionDeviceSmokeCd>"), l.sw_discounts.includes(2e3) && (o += "<ProtectionDeviceSprinklerCd>".concat(l.sprinklerId, "</ProtectionDeviceSprinklerCd>")), (l.sw_discounts.includes(2e3) || l.sw_discounts.includes(4200) || "05" == e.homeType || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305)) && (o += "<DoorLockCd>DEADB</DoorLockCd>"), (l.sw_discounts.includes(2e3) || l.sw_discounts.includes(4301) || l.sw_discounts.includes(4200) || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305) || "05" == e.homeType) && (o += "</BldgProtection>"), l.sw_discounts.includes(9099) && "TX" != l.state && "CO" != l.state && "OH" != l.state && "WA" != l.state && "VA" != l.state && (a += "<QuestionAnswer>\n                    <QuestionCd>HOME24</QuestionCd>\n                    <YesNoCd>YES</YesNoCd>\n                    </QuestionAnswer>"), l.sw_discounts.includes(800) && (r += mapper.getSWQuestionXML({
          question: "com.stillwater_HailResistiveRoof",
          answer: "YES"
        })), l.sw_discounts.includes(1700) && (i += "<QuestionAnswer>\n                    <QuestionCd>com.stillwater_RoofCoveringInstallCertificate</QuestionCd>\n                    <com.stillwater_Response>".concat(l.certificateId, "</com.stillwater_Response>\n                    </QuestionAnswer>")), l.sw_discounts.includes(4250) && (s += mapper.getSWQuestionXML({
          question: "com.stillwater_BurglarAlarmCertTX",
          answer: "YES"
        })), l.sw_discounts.includes(4350) && (c += mapper.getSWQuestionXML({
          question: "com.stillwater_DeadBoltLockingDeviceCertTX",
          answer: "YES"
        })), l.sw_discounts.includes(1150) && (h += mapper.getSWQuestionXML({
          question: "com.stillwater_ConstructionPermit",
          answer: "YES"
        })), console.log("stillwater_HailResistiveRoof_1", r), console.log("RoofCoveringInstallCertificate_2", i), console.log("stillwater_BurglarAlarmCertTX_1", s), console.log("stillwater_DeadBoltLockingDeviceCertTX_1", c), console.log("bldgProtection_1", o), console.log("stillwater_ConstructionPermit_1", h), {
          marriedStatus: n,
          construction: t,
          bldgProtection: o,
          home24: a,
          spouseDetails: u,
          stillwater_HailResistiveRoof: r,
          stillwater_RoofCoveringInstallCertificate: i,
          stillwater_BurglarAlarmCertTX: s,
          stillwater_DeadBoltLockingDeviceCertTX: c,
          stillwater_ConstructionPermit: h
        };
      }
    }, {
      key: "swQuoteDiscountXML",
      value: function (l, e) {
        var n = "",
          u = "",
          t = "",
          o = "",
          a = "",
          r = "",
          i = "",
          s = "",
          c = "",
          h = "";
        if (l.sw_discounts.includes(4965) || "M" == l.maritalStatus) {
          n += "<PersonInfo>";
          var d = this.formatDate(l.dob);
          console.log("swQuoteDiscountXML commonInput['dob']:", l.dob, "this.formatDate(commonInput['dob'])", d), l.dob.includes("NaN") || l.dob.includes("nan") || d.includes("NaN") || d.includes("nan") || "" == d ? console.log("Dob not added") : n += " <BirthDt>".concat(d, "</BirthDt>");
        } else {
          n += "<PersonInfo>";
          var p = this.formatDate(l.dob);
          console.log("swQuoteDiscountXML commonInput['dob']:", l.dob, "this.formatDate(commonInput['dob'])", p), l.dob.includes("NaN") || l.dob.includes("nan") || p.includes("NaN") || p.includes("nan") ? console.log("Dob not added") : n += " <BirthDt>".concat(p, "</BirthDt>");
        }
        if (n += " <MaritalStatusCd>".concat(l.maritalStatus ? l.maritalStatus : "M", "</MaritalStatusCd>\n                                </PersonInfo>"), ("M" == l.maritalStatus || "C" == l.maritalStatus) && l.partnerSpouseDetails || l.isCoApplicant && l.coApplicantDetails) {
          var m = "M" == l.maritalStatus || "C" == l.maritalStatus ? l.partnerSpouseDetails : l.isCoApplicant ? l.coApplicantDetails : {
            dob: ""
          };
          if (m.hasOwnProperty("dob") && "" != m.dob && "" != m.firstName && "" != m.lastName) {
            var C = this.formatDate(m.dob),
              g = "" != m.middleName ? "<OtherGivenName>".concat(m.middleName, "</OtherGivenName>") : "";
            u = "<InsuredOrPrincipal>\n                    <GeneralPartyInfo>\n                        <NameInfo>\n                        <PersonName>\n                            <Surname>".concat(m.lastName, "</Surname>\n                            <GivenName>").concat(m.firstName, " </GivenName>\n                            ").concat(g, "\n                        </PersonName>\n                        </NameInfo>\n                    </GeneralPartyInfo>\n                    <InsuredOrPrincipalInfo>\n                        <InsuredOrPrincipalRoleCd>AI</InsuredOrPrincipalRoleCd>\n                        <PersonInfo>\n                            <BirthDt>").concat(C, "</BirthDt>\n                        </PersonInfo>\n                    </InsuredOrPrincipalInfo>\n                </InsuredOrPrincipal>");
          }
        }
        return t += "<Construction>\n                                <YearBuilt>".concat(l.yearbuilt, "</YearBuilt>"), l.propertyDetails.foundationType ? t += " <FoundationCd>".concat(l.propertyDetails.foundationType, "</FoundationCd>\n            \x3c!--<NumStories>").concat(l.propertyDetails.stories, "</NumStories>--\x3e\n            \x3c!--<RoofingMaterial>\n                    <RoofMaterialCd>").concat(l.propertyDetails.roof_type, "</RoofMaterialCd>\n                </RoofingMaterial>--\x3e\n                                    <ElectricalPanelCd>CIRC</ElectricalPanelCd>") : t += "\n            \x3c!--<NumStories>".concat(l.propertyDetails.stories, "</NumStories>--\x3e\n            \x3c!--<RoofingMaterial>\n                    <RoofMaterialCd>").concat(l.propertyDetails.roof_type, "</RoofMaterialCd>\n                </RoofingMaterial>--\x3e\n                                    <ElectricalPanelCd>CIRC</ElectricalPanelCd>"), l.sw_discounts.includes(61) && l.ca_builder && ("" != l.ca_builder || null != l.ca_builder || null != l.ca_builder) && (t += "<com.stillwater_AccreditedBuilder>\n            <com.stillwater_BuilderNumber>".concat(l.ca_builder, "</com.stillwater_BuilderNumber>\n                                </com.stillwater_AccreditedBuilder > ")), l.sw_discounts.includes(1205) && l.roofShapeId && ("" != l.roofShapeId || null != l.roofShapeId || null != l.roofShapeId) && (t += " <RoofGeometryTypeCd>".concat(l.roofShapeId, "</RoofGeometryTypeCd>\n            ")), t += "</Construction > ", (l.sw_discounts.includes(2e3) || l.sw_discounts.includes(4301) || l.sw_discounts.includes(4200) || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305) || l.sw_discounts.includes(1202) || l.sw_discounts.includes(1203) || l.sw_discounts.includes(1207) || l.sw_discounts.includes(1204) || l.sw_discounts.includes(1213) || l.sw_discounts.includes(1208) || l.sw_discounts.includes(1214) || "05" == e.homeType) && (console.log("updated library===================="), o += "<BldgProtection>"), l.sw_discounts.includes(4301) && (o += "<FireExtinguisherInd>1</FireExtinguisherInd>"), l.sw_discounts.includes(1208) && (o += "<FireExtinguisherInd>0</FireExtinguisherInd>"), l.sw_discounts.includes(4305) && (o += "<ProtectionDeviceBurglarCd>CN</ProtectionDeviceBurglarCd>"), l.sw_discounts.includes(1204) && (o += "<ProtectionDeviceBurglarCd>LO</ProtectionDeviceBurglarCd>"), l.sw_discounts.includes(1213) && (o += "<ProtectionDeviceBurglarCd>NO</ProtectionDeviceBurglarCd>"), l.sw_discounts.includes(1214) && (o += "<ProtectionDeviceFireCd>CN</ProtectionDeviceFireCd>"), l.sw_discounts.includes(1202) && (o += "<ProtectionDeviceFireCd>LO</ProtectionDeviceFireCd>"), l.sw_discounts.includes(1203) && (o += "<ProtectionDeviceFireCd>NO</ProtectionDeviceFireCd>"), l.sw_discounts.includes(4200) && (o += "<ProtectionDeviceSmokeCd>DE</ProtectionDeviceSmokeCd>"), l.sw_discounts.includes(1207) && (o += "<ProtectionDeviceSmokeCd>NO</ProtectionDeviceSmokeCd>"), l.sw_discounts.includes(2e3) && (o += "<ProtectionDeviceSprinklerCd>".concat(l.sprinklerId, "</ProtectionDeviceSprinklerCd>")), l.sw_discounts.includes(4201) && (o += "<ProtectionDeviceSprinklerCd>NO</ProtectionDeviceSprinklerCd>"), l.sw_discounts.includes(4255) && (o += "<DoorLockCd>DEADB</DoorLockCd>"), (l.sw_discounts.includes(2e3) || l.sw_discounts.includes(4301) || l.sw_discounts.includes(4200) || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305) || l.sw_discounts.includes(1202) || l.sw_discounts.includes(1203) || l.sw_discounts.includes(1207) || l.sw_discounts.includes(1204) || l.sw_discounts.includes(1213) || l.sw_discounts.includes(1208) || l.sw_discounts.includes(1214) || "05" == e.homeType) && (o += "</BldgProtection>"), l.sw_discounts.includes(9099) && (a += "<QuestionAnswer>\n                    <QuestionCd>HOME24</QuestionCd>\n                    <YesNoCd>YES</YesNoCd>\n                    </QuestionAnswer>"), l.sw_discounts.includes(1209) && (a += "<QuestionAnswer>\n                    <QuestionCd>HOME24</QuestionCd>\n                    <YesNoCd>NO</YesNoCd>\n                    </QuestionAnswer>"), l.sw_discounts.includes(800) && (r += mapper.getSWQuestionXML({
          question: "com.stillwater_HailResistiveRoof",
          answer: "YES"
        })), l.sw_discounts.includes(1211) && (r += mapper.getSWQuestionXML({
          question: "com.stillwater_HailResistiveRoof",
          answer: "NO"
        })), l.sw_discounts.includes(1700) && (i += "<QuestionAnswer>\n                    <QuestionCd>com.stillwater_RoofCoveringInstallCertificate</QuestionCd>\n                    <com.stillwater_Response>".concat(l.certificateId, "</com.stillwater_Response>\n                    </QuestionAnswer>")), l.sw_discounts.includes(1212) && (i += "<QuestionAnswer>\n                    <QuestionCd>com.stillwater_RoofCoveringInstallCertificate</QuestionCd>\n                    <com.stillwater_Response>NO</com.stillwater_Response>\n                    </QuestionAnswer>"), l.sw_discounts.includes(4250) && (s += mapper.getSWQuestionXML({
          question: "com.stillwater_BurglarAlarmCertTX",
          answer: "YES"
        })), l.sw_discounts.includes(1206) && (s += mapper.getSWQuestionXML({
          question: "com.stillwater_BurglarAlarmCertTX",
          answer: "NO"
        })), l.sw_discounts.includes(4350) && (c += mapper.getSWQuestionXML({
          question: "com.stillwater_DeadBoltLockingDeviceCertTX",
          answer: "YES"
        })), l.sw_discounts.includes(1201) && (c += mapper.getSWQuestionXML({
          question: "com.stillwater_DeadBoltLockingDeviceCertTX",
          answer: "NO"
        })), l.sw_discounts.includes(1150) && (h += mapper.getSWQuestionXML({
          question: "com.stillwater_ConstructionPermit",
          answer: "YES"
        })), console.log("stillwater_HailResistiveRoof_1", r), console.log("RoofCoveringInstallCertificate_2", i), console.log("stillwater_BurglarAlarmCertTX_1", s), console.log("stillwater_DeadBoltLockingDeviceCertTX_1", c), console.log("bldgProtection_1", o), console.log("stillwater_ConstructionPermit_1", h), {
          marriedStatus: n,
          construction: t,
          bldgProtection: o,
          home24: a,
          spouseDetails: u,
          stillwater_HailResistiveRoof: r,
          stillwater_RoofCoveringInstallCertificate: i,
          stillwater_BurglarAlarmCertTX: s,
          stillwater_DeadBoltLockingDeviceCertTX: c,
          stillwater_ConstructionPermit: h
        };
      }
    }, {
      key: "swAppKnockoutXML",
      value: function (l, e, n) {
        var u = {
          "4pt7EffectiveDate": "",
          "4pt7OtherPolicy": "",
          "4pt8": "",
          "4pt11": "",
          "4pt12": "",
          "4pt13": "",
          "4pt14": "",
          "4pt16": "",
          "4pt17": "",
          "4pt19": "",
          "4pt20": "",
          "4pt21": "",
          "4pt22": "",
          "4pt24": ""
        };
        if (console.log("Stillwater appJson answers:", e), e.hasOwnProperty("sw_PolicyStartDate") && "" != e.sw_PolicyStartDate) {
          var t = new Date(e.sw_PolicyStartDate),
            o = new Date();
          t.getTime() < o.getTime() && (e.sw_PolicyStartDate = this.getTodayDate()), u["4pt7EffectiveDate"] += "<ContractTerm>\n                                            <EffectiveDt>".concat(this.formatDate(e.sw_PolicyStartDate), "</EffectiveDt>\n                                            <ExpirationDt>").concat(this.dateAfterOneYear(e.sw_PolicyStartDate), "</ExpirationDt>\n                                            <DurationPeriod>\n                                                <NumUnits>12</NumUnits>\n                                                <UnitMeasurementCd>MO</UnitMeasurementCd>\n                                            </DurationPeriod>\n                                        </ContractTerm>");
        }
        if (e.hasOwnProperty("sw_ExistingPolicy") && "yes" == e.sw_ExistingPolicy && "" != e.sw_ExistingPolicyNumber) {
          var a = "AUTOP";
          e.hasOwnProperty("sw_ExistingPolicyType") && "" != e.sw_ExistingPolicyType && (a = e.sw_ExistingPolicyType), u["4pt7OtherPolicy"] += "<OtherOrPriorPolicy>\n                                            <PolicyCd>Other</PolicyCd>\n                                            <PolicyNumber>".concat(e.sw_ExistingPolicyNumber, "</PolicyNumber>\n                                            <LOBCd>").concat(a, "</LOBCd>\n                                            <InsurerName>Stillwater</InsurerName>\n                                        </OtherOrPriorPolicy>");
        }
        if (e.hasOwnProperty("sw_agreeTerms") && "" != e.sw_agreeTerms && ("1" == e.sw_agreeTerms ? u["4pt8"] += mapper.getSWQuestionXML({
          question: "com.stillwater_InspectionNotification",
          answer: "YES"
        }) : u["4pt8"] += mapper.getSWQuestionXML({
          question: "com.stillwater_InspectionNotification",
          answer: "NO"
        })), e.hasOwnProperty("sw_InsuranceClaims") && "yes" == e.sw_InsuranceClaims) {
          for (var r = 1, i = 0; i < +e.sw_LiabilityRelatedLoss; i++) u["4pt11"] += '<Loss id="LOSS'.concat(r, '" LocationRef="LOC1">\n                                    <LossCauseCd>Liability</LossCauseCd>\n                                    <ClaimStatusCd>C</ClaimStatusCd>\n                                    </Loss>'), r += 1;
          for (var s = 0; s < +e.sw_WaterRelatedLoss; s++) u["4pt11"] += '<Loss id="LOSS'.concat(r, '" LocationRef="LOC1">\n                                        <LossCauseCd>Water</LossCauseCd>\n                                        </Loss>'), r += 1;
          for (var c = 0; c < +e.sw_WeatherRelatedLoss; c++) u["4pt11"] += '<Loss id="LOSS'.concat(r, '" LocationRef="LOC1">\n                                        <LossCauseCd>Weather</LossCauseCd>\n                                        </Loss>'), r += 1;
          for (var h = 0; h < +e.sw_OtherRelatedLoss; h++) u["4pt11"] += '<Loss id="LOSS'.concat(r, '" LocationRef="LOC1">\n                                        <LossCauseCd>Other</LossCauseCd>\n                                        <ClaimStatusCd>C</ClaimStatusCd>\n                                        </Loss>'), r += 1;
        }
        if (e.hasOwnProperty("sw_SwimmingPool") && "" != e.sw_SwimmingPool && ("yes" == e.sw_SwimmingPool ? (u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL15",
          answer: "YES"
        }), "sw_SwimmingPoolInfoNone" == e.sw_SwimmingPoolInfo && (u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL16",
          answer: "NO"
        })), "sw_SwimmingPoolInfoFullyEnclosed" == e.sw_SwimmingPoolInfo && (u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL16",
          answer: "YES"
        })), "sw_SwimmingPoolInfoUnfenced" == e.sw_SwimmingPoolInfo && (u["4pt12"] += mapper.getSWQuestionXML({
          question: "com.stillwater_PoolUnfenced",
          answer: "YES"
        })), "sw_SwimmingPoolInfoDivingBoard" == e.sw_SwimmingPoolInfo && (u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL17",
          answer: "YES"
        }))) : u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL15",
          answer: "NO"
        })), e.hasOwnProperty("sw_Vehicles") && "" != e.sw_Vehicles && ("no" == e.sw_Vehicles ? u["4pt13"] += mapper.getSWQuestionXML({
          question: "com.stillwater_UnusualVehicleStorage",
          answer: "NO"
        }) : u["4pt13"] += mapper.getSWQuestionXML({
          question: "com.stillwater_UnusualVehicleStorage",
          answer: "YES"
        })), e.hasOwnProperty("sw_trampolines") && "" != e.sw_trampolines && ("no" == e.sw_trampolines || e.sw_trampolinesPlacement.includes("sw_trampolinesPlacementFenced") && e.sw_trampolinesPlacement.includes("sw_trampolinesPlacementSafetyNet") ? u["4pt14"] += mapper.getSWQuestionXML({
          question: "GENRL31",
          answer: "NO"
        }) : u["4pt14"] += mapper.getSWQuestionXML({
          question: "GENRL31",
          answer: "YES"
        })), e.hasOwnProperty("sw_electricalPanel") && "" != e.sw_electricalPanel && (u["4pt16"] += "<Construction>\n                                <YearBuilt>".concat(l.yearbuilt, "</YearBuilt>\n                                \x3c!--<FoundationCd>BS</FoundationCd>--\x3e\n                                \x3c!--<NumStories>").concat(l.propertyDetails.stories, "</NumStories>--\x3e\n                                \x3c!--<RoofingMaterial>\n                                        <RoofMaterialCd>").concat(l.propertyDetails.roof_type, "</RoofMaterialCd>\n                                    </RoofingMaterial>--\x3e"), "sw_electricalPanelFuses" == e.sw_electricalPanel ? u["4pt16"] += "<ElectricalPanelCd>FUSE</ElectricalPanelCd>" : u["4pt16"] += "<ElectricalPanelCd>CIRC</ElectricalPanelCd>", l.sw_discounts.includes(61) && l.ca_builder && ("" != l.ca_builder || null != l.ca_builder || null != l.ca_builder) && (u["4pt16"] += "<com.stillwater_AccreditedBuilder>\n                                    <com.stillwater_BuilderNumber>".concat(l.ca_builder, "</com.stillwater_BuilderNumber>\n                                </com.stillwater_AccreditedBuilder>")), l.sw_discounts.includes(1205) && l.roofShapeId && ("" != l.roofShapeId || null != l.roofShapeId || null != l.roofShapeId) && (u["4pt16"] += " <RoofGeometryTypeCd>".concat(l.roofShapeId, "</RoofGeometryTypeCd>\n                ")), u["4pt16"] += "</Construction>"), e.hasOwnProperty("sw_roof") && "" != e.sw_roof && ("no" == e.sw_roof ? u["4pt17"] += mapper.getSWQuestionXML({
          question: "com.stillwater_RoofCondition",
          answer: "YES"
        }) : u["4pt17"] += mapper.getSWQuestionXML({
          question: "com.stillwater_RoofCondition",
          answer: "NO"
        })), e.hasOwnProperty("sw_roofAge") && "" != e.sw_roofAge && ("yes" == e.sw_roofAge ? u["4pt19"] += mapper.getSWQuestionXML({
          question: "com.com.stillwater_RoofLess20Year",
          answer: "YES"
        }) : u["4pt19"] += mapper.getSWQuestionXML({
          question: "com.com.stillwater_RoofLess20Year",
          answer: "NO"
        })), e.sw_solidFuelburner && "no" == e.sw_solidFuelburner && (u["4pt20"] += "<com.stillwater_SolidFuel>N</com.stillwater_SolidFuel>"), e.sw_solidFuelburnerProfessionallyInstalled && "no" == e.sw_solidFuelburnerProfessionallyInstalled && (u["4pt20"] += "<com.stillwater_SolidFuel>I</com.stillwater_SolidFuel>"), e.sw_solidFuelburnerPrimarySourceOfHeat && "" != e.sw_solidFuelburnerPrimarySourceOfHeat && ("yes" == e.sw_solidFuelburnerPrimarySourceOfHeat ? u["4pt20"] += "<com.stillwater_SolidFuel>P</com.stillwater_SolidFuel>" : u["4pt20"] += "<com.stillwater_SolidFuel>S</com.stillwater_SolidFuel>"), e.hasOwnProperty("sw_fireHydrant") || "05" == n.homeType) {
          if (u["4pt22"] += "<BldgProtection>", e.hasOwnProperty("sw_fireHydrant") && "" != e.sw_fireHydrant) {
            var d = "1001";
            "yes" == e.sw_fireHydrant && (d = "999"), u["4pt22"] += "<DistanceToHydrant>\n                                        <NumUnits>".concat(d, "</NumUnits>\n                                        <UnitMeasurementCd>FT</UnitMeasurementCd>\n                                    </DistanceToHydrant>");
          }
          (l.sw_discounts.includes(4200) || "05" == n.homeType || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305)) && (u["4pt22"] += "<FireExtinguisherInd>1</FireExtinguisherInd>"), l.sw_discounts.includes(4305) && (u["4pt22"] += "<ProtectionDeviceBurglarCd>CN</ProtectionDeviceBurglarCd>"), (l.sw_discounts.includes(4255) || l["sw_discounts".includes(4301)]) && (u["4pt22"] += "<ProtectionDeviceFireCd>CN</ProtectionDeviceFireCd>"), (l.sw_discounts.includes(4200) || "05" == n.homeType || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305)) && (u["4pt22"] += "<ProtectionDeviceSmokeCd>DE</ProtectionDeviceSmokeCd>"), l.sw_discounts.includes(4201) && (u["4pt22"] += "<ProtectionDeviceSprinklerCd>NO</ProtectionDeviceSprinklerCd>"), (l.sw_discounts.includes(4200) || "05" == n.homeType) && (u["4pt22"] += "<DoorLockCd>DEADB</DoorLockCd>"), u["4pt22"] += "</BldgProtection>";
        }
        return e.hasOwnProperty("sw_farming") && "" != e.sw_farming && ("yes" == e.sw_farming ? u["4pt24"] += mapper.getSWQuestionXML({
          question: "AGLIA24",
          answer: "YES"
        }) : u["4pt24"] += mapper.getSWQuestionXML({
          question: "AGLIA24",
          answer: "NO"
        })), u;
      }
    }, {
      key: "swAppKnockoutXMLTrack2",
      value: function (l, e, n) {
        var u = {
          "4pt7EffectiveDate": "",
          "4pt7OtherPolicy": "",
          "4pt8": "",
          "4pt10": "",
          "4pt11": "",
          "4pt12": "",
          "4pt13": "",
          "4pt14": "",
          "4pt16": "",
          "4pt17": "",
          "4pt19": "",
          "4pt20": "",
          "4pt21": "",
          "4pt22": "",
          "4pt24": ""
        };
        if (console.log("Stillwater appJson answers:", e), e.hasOwnProperty("sw_PolicyStartDate") && "" != e.sw_PolicyStartDate) {
          var t = new Date(e.sw_PolicyStartDate),
            o = new Date();
          t.getTime() < o.getTime() && (e.sw_PolicyStartDate = this.getTodayDate()), u["4pt7EffectiveDate"] += "<ContractTerm>\n                                            <EffectiveDt>".concat(this.formatDate(e.sw_PolicyStartDate), "</EffectiveDt>\n                                            <ExpirationDt>").concat(this.dateAfterOneYear(e.sw_PolicyStartDate), "</ExpirationDt>\n                                            <DurationPeriod>\n                                                <NumUnits>12</NumUnits>\n                                                <UnitMeasurementCd>MO</UnitMeasurementCd>\n                                            </DurationPeriod>\n                                        </ContractTerm>");
        }
        if (e.hasOwnProperty("sw_ExistingPolicy") && "yes" == e.sw_ExistingPolicy && "" != e.sw_ExistingPolicyNumber) {
          var a = "AUTOP";
          e.hasOwnProperty("sw_ExistingPolicyType") && "" != e.sw_ExistingPolicyType && (a = e.sw_ExistingPolicyType), u["4pt7OtherPolicy"] += "<OtherOrPriorPolicy>\n                                            <PolicyCd>Other</PolicyCd>\n                                            <PolicyNumber>".concat(e.sw_ExistingPolicyNumber, "</PolicyNumber>\n                                            <LOBCd>").concat(a, "</LOBCd>\n                                            <InsurerName>Stillwater</InsurerName>\n                                        </OtherOrPriorPolicy>");
        }
        if (u["4pt8"] += mapper.getSWQuestionXML({
          question: "com.stillwater_InspectionNotification",
          answer: "YES"
        }), e.hasOwnProperty("sw_SwimmingPool") && "" != e.sw_SwimmingPool && ("yes" == e.sw_SwimmingPool ? (u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL15",
          answer: "YES"
        }), e.sw_SwimmingPoolInfo.includes("sw_SwimmingPoolInfoNone") && (u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL16",
          answer: "NO"
        })), e.sw_SwimmingPoolInfo.includes("sw_SwimmingPoolInfoFullyEnclosed") && (u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL16",
          answer: "YES"
        })), e.sw_SwimmingPoolInfo.includes("sw_SwimmingPoolInfoUnfenced") ? u["4pt12"] += mapper.getSWQuestionXML({
          question: "com.stillwater_PoolUnfenced",
          answer: "YES"
        }) : u["4pt12"] += mapper.getSWQuestionXML({
          question: "com.stillwater_PoolUnfenced",
          answer: "NO"
        }), e.sw_SwimmingPoolInfo.includes("sw_SwimmingPoolInfoDivingBoard") ? u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL17",
          answer: "YES"
        }) : u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL17",
          answer: "NO"
        })) : "no" == e.sw_SwimmingPool && e.sw_SwimmingPoolInfo.length > 0 ? (u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL15",
          answer: "NO"
        }), u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL17",
          answer: "NO"
        }), u["4pt12"] += mapper.getSWQuestionXML({
          question: "com.stillwater_PoolUnfenced",
          answer: "NO"
        })) : u["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL15",
          answer: "NO"
        })), e.hasOwnProperty("sw_Vehicles") && "" != e.sw_Vehicles && ("no" == e.sw_Vehicles ? u["4pt13"] += mapper.getSWQuestionXML({
          question: "com.stillwater_UnusualVehicleStorage",
          answer: "NO"
        }) : u["4pt13"] += mapper.getSWQuestionXML({
          question: "com.stillwater_UnusualVehicleStorage",
          answer: "YES"
        })), e.hasOwnProperty("sw_trampolines") && "" != e.sw_trampolines && ("no" == e.sw_trampolines || e.sw_trampolinesPlacement.includes("sw_trampolinesPlacementFenced") && e.sw_trampolinesPlacement.includes("sw_trampolinesPlacementSafetyNet") ? u["4pt14"] += mapper.getSWQuestionXML({
          question: "GENRL31",
          answer: "NO"
        }) : u["4pt14"] += mapper.getSWQuestionXML({
          question: "GENRL31",
          answer: "YES"
        })), e.hasOwnProperty("sw_electricalPanel") && "" != e.sw_electricalPanel && (u["4pt16"] += "<Construction>\n                                <YearBuilt>".concat(l.yearbuilt, "</YearBuilt>\n                                \x3c!--<FoundationCd>BS</FoundationCd>--\x3e\n                                \x3c!--<NumStories>").concat(l.propertyDetails.stories, "</NumStories>--\x3e\n                                \x3c!--<RoofingMaterial>\n                                        <RoofMaterialCd>").concat(l.propertyDetails.roof_type, "</RoofMaterialCd>\n                                    </RoofingMaterial>--\x3e"), "yes" == e.sw_electricalPanel ? u["4pt16"] += "<ElectricalPanelCd>FUSE</ElectricalPanelCd>" : u["4pt16"] += "<ElectricalPanelCd>CIRC</ElectricalPanelCd>", l.sw_discounts.includes(61) && l.ca_builder && ("" != l.ca_builder || null != l.ca_builder || null != l.ca_builder) && (u["4pt16"] += "<com.stillwater_AccreditedBuilder>\n                                    <com.stillwater_BuilderNumber>".concat(l.ca_builder, "</com.stillwater_BuilderNumber>\n                                </com.stillwater_AccreditedBuilder>")), l.sw_discounts.includes(1205) && l.roofShapeId && ("" != l.roofShapeId || null != l.roofShapeId || null != l.roofShapeId) && (u["4pt16"] += " <RoofGeometryTypeCd>".concat(l.roofShapeId, "</RoofGeometryTypeCd>\n                ")), u["4pt16"] += "</Construction>"), e.hasOwnProperty("sw_roof") && "" != e.sw_roof && ("no" == e.sw_roof ? u["4pt17"] += mapper.getSWQuestionXML({
          question: "com.stillwater_RoofCondition",
          answer: "YES"
        }) : u["4pt17"] += mapper.getSWQuestionXML({
          question: "com.stillwater_RoofCondition",
          answer: "NO"
        })), e.sw_solidFuelburner && "no" == e.sw_solidFuelburner && (u["4pt20"] += "<com.stillwater_SolidFuel>N</com.stillwater_SolidFuel>"), e.sw_solidFuelburnerProfessionallyInstalled && "no" == e.sw_solidFuelburnerProfessionallyInstalled && (u["4pt20"] += "<com.stillwater_SolidFuel>I</com.stillwater_SolidFuel>"), e.sw_solidFuelburnerPrimarySourceOfHeat && "" != e.sw_solidFuelburnerPrimarySourceOfHeat && ("yes" == e.sw_solidFuelburnerPrimarySourceOfHeat ? u["4pt20"] += "<com.stillwater_SolidFuel>P</com.stillwater_SolidFuel>" : u["4pt20"] += "<com.stillwater_SolidFuel>S</com.stillwater_SolidFuel>"), e.hasOwnProperty("sw_fireHydrant") || "05" == n.homeType) {
          if (u["4pt22"] += "<BldgProtection>", e.hasOwnProperty("sw_fireHydrant") && "" != e.sw_fireHydrant) {
            var r = "1001";
            "no" == e.sw_fireHydrant && (r = "999"), u["4pt22"] += "<DistanceToHydrant>\n                                        <NumUnits>".concat(r, "</NumUnits>\n                                        <UnitMeasurementCd>FT</UnitMeasurementCd>\n                                    </DistanceToHydrant>");
          }
          (l.sw_discounts.includes(4200) || "05" == n.homeType || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305)) && (u["4pt22"] += "<FireExtinguisherInd>1</FireExtinguisherInd>"), l.sw_discounts.includes(4305) && (u["4pt22"] += "<ProtectionDeviceBurglarCd>CN</ProtectionDeviceBurglarCd>"), (l.sw_discounts.includes(4255) || l.sw_discounts.includes(4301)) && (u["4pt22"] += "<ProtectionDeviceFireCd>CN</ProtectionDeviceFireCd>"), (l.sw_discounts.includes(4200) || "05" == n.homeType || l.sw_discounts.includes(4255) || l.sw_discounts.includes(4305)) && (u["4pt22"] += "<ProtectionDeviceSmokeCd>DE</ProtectionDeviceSmokeCd>"), l.sw_discounts.includes(4201) && (u["4pt22"] += "<ProtectionDeviceSprinklerCd>NO</ProtectionDeviceSprinklerCd>"), (l.sw_discounts.includes(4200) || "05" == n.homeType) && (u["4pt22"] += "<DoorLockCd>DEADB</DoorLockCd>"), u["4pt22"] += "</BldgProtection>";
        }
        if (e.hasOwnProperty("sw_ocean")) {
          if (u["4pt10"] += "<DwellStateSupplement>", e.hasOwnProperty("sw_ocean") && "" != e.sw_ocean) {
            var i = "1001";
            "yes" == e.sw_ocean && (i = "999"), u["4pt10"] += "<DistanceToOceanOrOtherBodyWater>\n                                        <NumUnits>".concat(i, "</NumUnits>\n                                        <UnitMeasurementCd>FT</UnitMeasurementCd>\n                                    </DistanceToOceanOrOtherBodyWater>");
          }
          u["4pt10"] += "</DwellStateSupplement>";
        }
        return e.hasOwnProperty("sw_farming") && "" != e.sw_farming && ("yes" == e.sw_farming ? u["4pt24"] += mapper.getSWQuestionXML({
          question: "AGLIA24",
          answer: "YES"
        }) : u["4pt24"] += mapper.getSWQuestionXML({
          question: "AGLIA24",
          answer: "NO"
        })), u;
      }
    }, {
      key: "swPrebind",
      value: (n = _asyncToGenerator(_regeneratorRuntime.mark(function l(e, n, u) {
        var t, o, a, r;
        return _regeneratorRuntime.wrap(function (l) {
          for (;;) switch (l.prev = l.next) {
            case 0:
              return t = mapper.getSWPrebindXML(e, n), console.log("xmlInputString", t), t = t.replace("ISPREBIND_PLACEHOLDER", "<com.stillwater_IsPreBind>1</com.stillwater_IsPreBind>"), o = "".concat(u, "_sw_prebind_").concat(Date.now()), a = {
                client_id: u,
                email_id: "",
                phone: "",
                action_type: "api",
                full_name: "",
                carrier: "STILLWATER",
                lob: "HOME",
                functionality_group: "SW_PREBIND",
                session_id: "",
                api_group_id: "",
                dynamodb_id: o,
                tags: ""
              }, backendService.bo_log(a, "api"), l.next = 8, this.invokeSWApi(t, o, "bind");
            case 8:
              return r = l.sent, l.abrupt("return", {
                swOutput: r
              });
            case 10:
            case "end":
              return l.stop();
          }
        }, l, this);
      })), function (l, e, u) {
        return n.apply(this, arguments);
      })
    }, {
      key: "swBindPayment",
      value: (e = _asyncToGenerator(_regeneratorRuntime.mark(function l(e, n, u, t, o, a) {
        var r, i, s, c, h, d, p, m, C, g, v, _, f;
        return _regeneratorRuntime.wrap(function (l) {
          for (;;) switch (l.prev = l.next) {
            case 0:
              if (r = {}, r = a.payType ? a : u.paymentDetails ? u.paymentDetails : {
                payType: "com.stillwater_DB01",
                paymentOption: "",
                paymentOptionPlan: "",
                depositAmount: "",
                paymentAmount: "325.05",
                installmentAmount: "",
                policyStartDate: "",
                paymentMethod: "",
                firstName: "Sunny",
                lastName: "KP",
                cardNumber: "",
                cardType: "VISA",
                expiryDate: "2022-12",
                cvv: "",
                billingAddress: "",
                routing: "102000076",
                accountNumber: "4111111111111111",
                paymentDueDay: "10",
                accountType: "",
                termsAndCondtions: ""
              }, i = r.paymentAmount.replace("$", "").replace(/,/g, "").replace(/ /g, ""), s = mapper.getSWBindXML(e, n), c = "", c = "<PaymentOption>\n                            <PaymentPlanCd>".concat(r.payType, "</PaymentPlanCd>"), "com.stillwater_DB16" == r.payType && (c += "<MethodPaymentCd>OT</MethodPaymentCd>"), "com.stillwater_DB16" != r.payType && ("com.stillwater_EF12" == r.payType || "eft" == r.paymentMethod ? (c += "<MethodPaymentCd>EFT</MethodPaymentCd>", c += "<ElectronicFundsTransfer>\n                                    <FromAcct>\n                                        <AccountNumberId>".concat(r.accountNumber, "</AccountNumberId>"), c += "<BankInfo><BankId>".concat(r.routing, "</BankId></BankInfo>")) : (c += "<MethodPaymentCd>".concat(r.cardType.toUpperCase(), "</MethodPaymentCd>"), c += "<ElectronicFundsTransfer>\n                                    <FromAcct>\n                                        <AccountNumberId>".concat(r.cardNumber, "</AccountNumberId>"), c += "<CreditCardExpirationDt>".concat(r.expiryDate, "</CreditCardExpirationDt>")), c += "</FromAcct>\n                                    <TransferAmt>\n                                        <Amt>".concat(i, "</Amt>\n                                    </TransferAmt>\n                                </ElectronicFundsTransfer>"), "com.stillwater_CC70" == r.payType && (h = new Date(), d = h.getDate(), c += "<com.stillwater_PaymentDueDay>".concat(d, "</com.stillwater_PaymentDueDay>")), "com.stillwater_EF12" != r.payType && "eft" != r.paymentMethod && (c += "<SignatureInfo>\n                                        <NameInfo>\n                                            \x3c!--  Card holder name  --\x3e\n                                            <PersonName>\n                                                <Surname>".concat(r.lastName, "</Surname>\n                                                <GivenName>").concat(r.firstName, "</GivenName>\n                                                \x3c!-- <OtherGivenName></OtherGivenName> --\x3e\n                                            </PersonName>\n                                        </NameInfo>\n                                    </SignatureInfo>"))), c += "</PaymentOption>", p = "", m = {}, console.log(u.sw_mortgageDetails), u.sw_mortgage && "yes" == u.sw_mortgage) for (C = 0; C < u.sw_mortgageDetails.length; C++) m = u.sw_mortgageDetails[C].sw_mortgageLenderObject, p += "<AdditionalInterest>\n                                        <GeneralPartyInfo>\n                                            <NameInfo>\n                                                <CommlName>\n                                                    <CommercialName>".concat(m.lenderName, "</CommercialName>\n                                                </CommlName>\n                                            </NameInfo>\n                                            <Addr>\n                                                \x3c!--<Addr1>").concat(m.address1, "</Addr1> --\x3e\n                                                <Addr1>").concat(m.address2, "</Addr1>\n                                                <City>").concat(m.city, "</City>\n                                                <StateProvCd>").concat(m.state, "</StateProvCd>\n                                                <PostalCode>").concat(m.zipcode, "</PostalCode>\n                                            </Addr>\n                                        </GeneralPartyInfo>\n                                        <AdditionalInterestInfo>\n                                            <NatureInterestCd>MORTG</NatureInterestCd>\n                                            <InterestRank>").concat(C + 1, "</InterestRank>"), u.sw_mortgageDetails[C].sw_mortgageLoanNumber && "" != u.sw_mortgageDetails[C].sw_mortgageLoanNumber && (p += "<AccountNumberId>".concat(u.sw_mortgageDetails[C].sw_mortgageLoanNumber.toUpperCase(), "</AccountNumberId>")), p += "<com.stillwater_BillMortgagee>".concat(u.sw_mortgageDetails[C].sw_mortgageFutureRenewal.toUpperCase(), "</com.stillwater_BillMortgagee>\n                                        </AdditionalInterestInfo>\n                                    </AdditionalInterest>");
              return g = "", g += "<PersApplicationInfo>\n                            <InsuredOrPrincipal>\n                                <GeneralPartyInfo>\n                                    <Addr>\n                                        <AddrTypeCd>MailingAddress</AddrTypeCd>\n                                        <Addr1>".concat(e.address, "</Addr1>\n                                        <City>").concat(e.city, "</City>\n                                        <StateProvCd>").concat(e.state, "</StateProvCd>\n                                        <PostalCode>").concat(e.zip, "</PostalCode>\n                                    </Addr>\n                                </GeneralPartyInfo>\n                            </InsuredOrPrincipal>\n                            <Addr>\n                                <AddrTypeCd>BillingAddress</AddrTypeCd>\n                                <Addr1>").concat(r.billingAddress.address, "</Addr1>\n                                <City>").concat(r.billingAddress.city, "</City>\n                                <StateProvCd>").concat(r.billingAddress.state, "</StateProvCd>\n                                <PostalCode>").concat(r.billingAddress.zip, "</PostalCode>\n                            </Addr>"), u.sw_vesting && "yes" == u.sw_vesting && (g += "<com.stillwater_VestingInfo>\n                                <StatementLine1>".concat(u.sw_vestingDetails, "</StatementLine1>\n                            </com.stillwater_VestingInfo>")), g += "</PersApplicationInfo>", s = (s = (s = (s = (s = s.replace("PAYMENTOPTION_PLACEHOLDER", c)).replace("ADDITIONALINTEREST_PLACEHOLDER", p)).replace("ACKNOWLEDGEMENT_PLACEHOLDER", "<QuestionAnswer>\n                                    <QuestionCd>com.stillwater_AcknowledgementInd</QuestionCd>\n                                    <YesNoCd>YES</YesNoCd>\n                                </QuestionAnswer>")).replace("PERSAPPINFO_PLACEHOLDER", g)).replaceAll("RQUID_PLACEHOLDER", e.sw_rquid || "00000000-0000-0000-0000-000000000000"), s = mapper.cleanSWXML(s), console.log("xmlInputString", s), v = "".concat(t, "_sw_bindpayment_").concat(Date.now()), _ = {
                client_id: t,
                email_id: "",
                phone: "",
                action_type: "api",
                full_name: "",
                carrier: "STILLWATER",
                lob: "HOME",
                functionality_group: "SW_BINDPAYMENT",
                session_id: "",
                api_group_id: "",
                dynamodb_id: v,
                tags: ""
              }, backendService.bo_log(_, "api"), l.next = 31, this.invokeSWApi(s, v, "bind");
            case 31:
              return f = l.sent, l.abrupt("return", {
                swOutput: f
              });
            case 33:
            case "end":
              return l.stop();
          }
        }, l, this);
      })), function (l, n, u, t, o, a) {
        return e.apply(this, arguments);
      })
    }, {
      key: "getDwellInspection",
      value: function (l) {
        return "" != l.propertyDetails.stories ? "<DwellInspectionValuation>\n                    <NumFamilies>1</NumFamilies>\n                    <NumStoriesInDwellingCd>".concat(l.propertyDetails.stories, "</NumStoriesInDwellingCd>\n                    <TotalLivingArea>\n                        <NumUnits>").concat(l.propertyDetails.living_size, "</NumUnits>\n                    </TotalLivingArea>\n                </DwellInspectionValuation>") : "<DwellInspectionValuation>\n                    <NumFamilies>1</NumFamilies>\n                    <TotalLivingArea>\n                        <NumUnits>".concat(l.propertyDetails.living_size, "</NumUnits>\n                    </TotalLivingArea>\n                </DwellInspectionValuation>");
      }
    }, {
      key: "getBldgImprovementXml",
      value: function (l) {
        return l.propertyDetails.roof_constructed && "" != l.propertyDetails.roof_constructed ? "<BldgImprovements>\n                <RoofingImprovementYear>".concat(l.propertyDetails.roof_constructed, "</RoofingImprovementYear>\n                </BldgImprovements>") : "";
      }
    }, {
      key: "getSSNConsentXml",
      value: function () {
        return "<QuestionAnswer>\n        <QuestionCd>CreditConsent</QuestionCd>\n        <YesNoCd>YES</YesNoCd>\n        </QuestionAnswer>";
      }
    }, {
      key: "getPrevAddressXML",
      value: function (l, e) {
        var n = "",
          u = parseInt(e);
        return new Date().getFullYear() - u <= 2 && l.sw_previousMailingAddress && "" != l.sw_previousMailingAddress.address && (n = "<Addr>\n                    <AddrTypeCd>PreviousAddress</AddrTypeCd>\n                    <Addr1>".concat(l.sw_previousMailingAddress.address, "</Addr1>\n                    <City>").concat(l.sw_previousMailingAddress.city, "</City>\n                    <StateProvCd>").concat(l.sw_previousMailingAddress.state, "</StateProvCd>\n                    <PostalCode>").concat(l.sw_previousMailingAddress.zip, "</PostalCode>\n                </Addr>")), n;
      }
    }, {
      key: "getPrevAddressXMLfromCommonInput",
      value: function (l) {
        if (null != l && l.address) {
          var e = "";
          l.unitNo && "" != l.unitNo && (e = "<Addr2>".concat(l.unitNo, "</Addr2>"));
          return "<Addr>\n                    <AddrTypeCd>PreviousAddress</AddrTypeCd>\n                    <Addr1>".concat(l.address, "</Addr1>\n                    ").concat(e, "\n                    <City>").concat(l.city, "</City>\n                    <StateProvCd>").concat(l.stateCode, "</StateProvCd>\n                    <PostalCode>").concat(l.zip, "</PostalCode>\n                </Addr>");
        }
        return "";
      }
    }, {
      key: "getCommunicationXml",
      value: function (l) {
        var e = 0;
        if (l.phone) {
          var n = l.phone.split("-");
          e = n[n.length - 1].match(/\d+/g).join("").length, console.log(l.phone, e);
        }
        return l.phone && "" != l.phone && 4 == e ? "<Communications>\n                    <PhoneInfo>\n                        <CommunicationUseCd>Home</CommunicationUseCd>\n                        <PhoneNumber>+1-".concat(l.phone, "</PhoneNumber>\n                    </PhoneInfo>\n                    <EmailInfo>\n                        <EmailAddr>").concat(l.email, "</EmailAddr>\n                    </EmailInfo>\n                    <com.stillwater_Paperless>Y</com.stillwater_Paperless>\n                </Communications>") : "<Communications>\n                <EmailInfo>\n                    <EmailAddr>".concat(l.email, "</EmailAddr>\n                </EmailInfo>\n                <com.stillwater_Paperless>Y</com.stillwater_Paperless>\n            </Communications>");
      }
    }, {
      key: "getSecondOwner",
      value: function (l, e) {
        return "<InsuredOrPrincipal>\n                    <GeneralPartyInfo>\n                        <NameInfo>\n                            <PersonName>\n                                <Surname>".concat(e.sw_secondOwnerLastName, "</Surname>\n                                <GivenName>").concat(e.sw_secondOwnerFirstName, "</GivenName>\n                            </PersonName>\n                        </NameInfo>\n                    </GeneralPartyInfo>\n                    <InsuredOrPrincipalInfo>\n                        <InsuredOrPrincipalRoleCd>AI</InsuredOrPrincipalRoleCd>\n                        <PersonInfo>\n                            <BirthDt>").concat(this.formatDate(e.sw_secondOwnerDOB), "</BirthDt>\n                        </PersonInfo>\n                    </InsuredOrPrincipalInfo>\n                </InsuredOrPrincipal>");
      }
    }, {
      key: "getQuoteKnockoutXML",
      value: function (l) {
        var e = {
            375: "com.stillwater_ExistingDamage",
            525: "com.stillwater_MultiFamily",
            25: "com.stillwater_CoverageLapse",
            43: "com.stillwater_NonPaymentCancellation",
            3050: "GENRL20",
            2256: "com.stillwater_ExtendedVacancy"
          },
          n = [];
        "NJ" != l.state && "TX" != l.state || (n = ["25", "43"]);
        var u = "";
        if (l.swquote_question) for (var t in e) n.includes(t) || (l.swquote_question.includes(parseInt(t)) ? u += mapper.getSWQuestionXML({
          question: e[t],
          answer: "YES"
        }) : u += mapper.getSWQuestionXML({
          question: e[t],
          answer: "NO"
        }));
        return console.log("swquote_question01", u), u;
      }
    }, {
      key: "getPolicyNumberXML",
      value: function (l) {
        return "<QuoteInfo>\n                    <CompanysQuoteNumber>".concat(l, "</CompanysQuoteNumber>\n                </QuoteInfo>");
      }
    }, {
      key: "getDynamicLabels",
      value: function (l) {
        return {
          acc_rc: "RCC" == l.acc_rc ? "Replacement Cost" : "Actual Cash Value",
          erc: null != l.extended_replacement ? "".concat(l.extended_replacement, "% of Dwelling Coverage ") : "Not Covered"
        };
      }
    }, {
      key: "getHcbData",
      value: function (l) {
        return l.home_cyberbase ? "$" + this.numberWithCommas(l.home_cyberbase[0]) + "/$" + this.numberWithCommas(l.home_cyberbase[1]) : l.hcbpackage_databreach ? "$" + this.numberWithCommas(l.hcbpackage_databreach[0]) + "/$" + this.numberWithCommas(l.hcbpackage_databreach[1]) : l.hcbbreach_bullying ? "$" + this.numberWithCommas(l.hcbbreach_bullying[0]) + "/$" + this.numberWithCommas(l.hcbbreach_bullying[1]) : "Not Covered";
      }
    }, {
      key: "getSWToolTips",
      value: function (l) {
        var e = {
          deductible: {
            title: "Deductible",
            text: "The deductible is the amount that's deducted from the settlement of a claim. As an example, if a deductible of $500 is selected, the policyholder will pay the first $500 for each covered loss under the policy. In some cases there may be a different deductible for certain specified coverages, such as Wind or Hail coverage. If this is the case,the policy will have 2 deductibles: one for Wind/Hail and one for everything else."
          },
          dwelling: {
            title: "Dwelling Coverage",
            text: "If there is damage that can be covered, this is the highest amount of coverage that we will provide to rebuild or repair the aforementioned damage to the home or attached structures like garages, decks, or breezeways with the same or similar material quality. We have displayed the Dwelling Coverage (also referred to as Coverage A) calculated from the information provided, as well as other factors. \n \nThe Extended Replacement Cost (ERC) is an added protection that increases your standard home coverage by an additional 25% or 50% (depending on the plan you select) in case the cost of rebuilding your home, following damage, is higher than expected. This may occur, for example, when the price of local labor or materials rises, due to inflation or catastrophic events.\n \n Note: Dwelling Coverage is not the same as the purchase price or market value of the home. We only cover the home and attached structures, and not the land or detached structures (detached structures coverage is listed separately below). Please be sure that you are comfortable with the amount shown and that it is sufficient to adequately protect the home."
          },
          other_structure: {
            title: "Other Structures",
            text: "Other Structures covers those structures on the premises that aren't permanently connected to the home. Examples are: detached garages, driveway, fences, pools and pool-houses and storage sheds.\n \n The policy automatically includes Other Structures coverage to 10% of the Dwelling Coverage limit (Coverage A). Please contact us if additional coverage is needed.\n \n Other Structures is also referred to as Coverage B."
          },
          personal_property: {
            title: "Personal Property",
            text: "Personal Property Coverage protects the personal belongings for covered losses up to the limit chosen. They are covered if lost or damaged in the insured's home or car, or even if in the insured's possession while away from home.\n \n You can select the amount of Personal Property coverage needed from the options on the screen, typically 50%, 55% or 75% of the Dwelling Coverage (Coverage A). \n You can also select ACV or RC. \n \n ACV means Actual Cash Value, which is the current value of the item after depreciation for age, use and wear and tear. This may not cover the full replacement of the lost or damaged item.\n \n RC means Replacement Cost, which is the cost to replace the item(s), without deductions for depreciation. The policy will pay the lesser of the Replacement Cost, the cost to repair the item(s) or the limit of the Personal Property Coverage, subject to additional policy restrictions.\n \n Important Note: Special lower limits of coverage apply to certain valuables such as jewelry, computers and electronics, firearms, business items, collectibles, rugs, cameras, antiques and paintings.\n \n Personal Property is also referred to as Coverage C"
          },
          loss_of_use: {
            title: "Loss of Use",
            text: "Loss of Use covers the cost of additional living expenses incurred when a covered loss occurs and the home becomes uninhabitable. Reimbursement of these additional living expenses covers the cost of maintaining a normal standard of living while the Insured can't live in their home.\n The policy automatically includes Loss of Use coverage at 40% of the Dwelling Coverage limit (Coverage A).\n Loss of Use is also refered to as Coverage D. "
          },
          liability: {
            title: "Liability",
            text: "This covers injury or damage that the insured causes to the persons or property of others or that happens on the insured property. For example, someone trips and falls while in the home, is badly hurt and sues for damages."
          },
          medical_payment: {
            title: "Medical Payment",
            text: "This covers medical expenses within three years from the date of a covered accident. This includes reasonable charges for medical, surgical, x-ray, dental, ambulance, hospital, professional nursing, prosthetic devices and funeral services."
          },
          acc_rc: {
            title: "",
            text: ""
          },
          inflation_guard: {
            title: "Inflation Guard",
            text: "This is an optional annual adjustment in coverage to keep pace with inflation and the increases in the cost of materials and labor. The limits of liability for Coverage A, B, C and D (respectively: the home, other structures, personal property and the loss of use of the home) will be increased annually by the percentage amount available or that you select. Certain restrictions and exclusions apply."
          },
          building_ordinance: {
            title: "Building Ordinance or Law",
            text: "This allows the insured to use up to 50% of the limit of liability that applies to Coverage A (the basic dwelling coverage) for the increased costs incurred to bring the home up to the current local building codes and standards. This coverage is additional insurance."
          },
          common_construction: {
            title: "Common Construction",
            text: "The Functional Replacement Cost endorsement is included for homes over 60 years old.\n \n The loss settlement provision provided under Coverage A(the Dwelling) and Coverage B(Other Structures) is on a functional replacement cost basis. This coverage is considered to be optional for homes built within the last 60 years.\n \n Functional replacement cost means the amount which it would cost to repair or replace the damaged building with less costly common construction materials and methods which are functionally equivalent to obsolete, antique or custom construction materials and methods used in the original construction of the building. If the dwelling is constructed with upgraded building materials (marble, tile etc.) or recent construction made to look like antique, it will be replaced with like kind materials and methods. Additionally, custom construction that does not consist of unusual or irreplaceable construction will also be replaced with like kind materials and methods.\n \n Please note that the existence of unusual or irreplaceable construction would make the property ineligible. "
          },
          extended_replacement: {
            title: "Extended Replacement Cost",
            text: "The Extended Replacement Cost (ERC) is an added protection that increases your standard home coverage by an additional 25% or 50% (depending on the plan you select) in case the cost of rebuilding your home, following damage, is higher than expected. This may occur, for example, when the price of local labor or materials rises, due to inflation or catastrophic events"
          },
          animal_liability: {
            title: "Animal Liability",
            text: "All policies exclude coverage for Animal Liability unless the Animal Liability endorsement has been added. Animal Liability cannot be purchased if there is a prohibited breed of dog, or a dog with a prior bite history, in the household. Prohibited dogs are Akita, Alaskan Malamute, American Staffordshire Terriers, Chow, Dalmatian, Doberman Pinscher, Husky, Pit Bull, Presa Canario (Canary dog), Rottweiler, Staffordshire Bull Terriers, Wolf-dogs and Wolf hybrids, or a mixed breed of any of the ones listed. The amount of coverage chosen must be equal to or less than the Liability limit, but cannot be more than $300,000. Certain restrictions and exclusions apply."
          },
          water_backup: {
            title: "Water Back up",
            text: "This optional endorsement covers direct physical loss, not caused by the insured's negligence, to the residence and personal property in the residence damaged by water that backs up through sewers or drains or overflows or is discharged from a sump, sump pump or related equipment. It also covers the extra costs if the insured has to move out of the home and stay somewhere else while a covered loss is being handled. There's no coverage for the breakdown or damage to the actual sump pump, or related equipment. Certain restrictions and exclusions apply."
          },
          homesys_protect: {
            title: "Home System Protection",
            text: "The policy may be endorsed to provide coverage for direct physical damage to the home systems and personal property that are essential to heating, cooling, comfort, convenience and operation of the home due to mechanical or electrical breakdown.\n \n Examples of covered Home Equipment: \n •Furnaces, boilers and heat pumps\n •Water treatment and filtration \n •Radiant and geothermal heating systems\n •Emergency generators\n •Air Conditioning and ventilation\n •Fire and security alarm systems\n •Electrical distribution panels\n •Pool pumps and filtration\n •Water heaters\n •Auto charging stations \n \n Examples of covered Personal Property: \n ◾Kitchen and laundry appliances\n ◾Home exercise equipment\n ◾Home entertainment electronics\n ◾Home tools and workshop equipment \n ◾Computers, laptops and tablets\n ◾Lawn and garden equipment\n ◾Health monitoring systems \n \n The limit of liability under this endorsement is dependent upon the age of the covered home equipment. The most that will be paid due to a home system breakdown to covered equipment or property is:\n ◾ $100,000 if less than 15 years old; or \n ◾$1,500 if 15 years old or older. "
          },
          identity_protection: {
            title: "Identity Theft Protection",
            text: "Coverage provides up to $25,000 for expenses incurred by an insured as the direct results of any one identity theft discovered during the policy period.  Additionally, the insured will have access to resolution services from a consumer fraud specialist who will assist in the process of restoring the insured's identity."
          },
          identity_recovery: {
            title: "Identity Recovery",
            text: "The Identity Recovery (IDR) endorsement provides Coverage for Identity Recovery caused by an ''identity theft'' that is first discovered during the Policy Period. Coverage includes Expense Reimbursement and Case Management Service. A limit of $25,000 is available and a deductible does not apply."
          },
          serviceline: {
            title: "Service Line",
            text: "The policy may be endorsed to provide coverage for direct physical damage to the service lines connected to the residence premises and owned by or the responsibility of the owner for its repair or replacement. A covered service line ends at the precise location where the homeowner's responsibility for such repair or replacement ends. Coverage does not extend beyond the point of connection to the main service or utility line in the street.\n \nA covered service line is exterior underground piping and wiring, including permanent connections, valves or attached devices providing one of the following services to the residence premises:\n •Water service \n •Geothermal  \n •Waste disposal \n •Electrical power \n •Heating \n •Drainage \n •Natural Gas \n •Compressed Air \n •Propane \n •Communications \n •Steam"
          },
          loss_asessment: {
            title: "Loss Assessment",
            text: "Loss assessment coverage helps pay for damage or liability that exceeds the Homeowner's Association master policy limits. When damage to, or liability caused by, community-owned property (for example a club-house, pool or walkway) costs more than it is insured for, the insured and other property owners could be responsible for paying the difference. Loss assessment coverage helps pay for this out-of-pocket difference. For example if the club-house suffers $600,000 fire damage and the Association's policy limit is $500,000 the insured and the other members would have to pay a proportional share of the uncovered $100,000.\n \n The policy includes Basic Loss Assessment coverage which pays up to $1,000 per eligible assessment for covered claims related to that community property. Supplemental Loss Assessment coverage adds extra coverage per loss, for an additional premium. Certain restrictions and exclusions apply."
          },
          wind_hail: {
            title: "Wind/Hail Deductible",
            text: "The deductible is the amount that's deducted from the settlement of a claim. For claims involving Wind or Hail it is a percentage of the amount of the Dwelling or Personal Property coverage, depending on the type of policy.\n \n For example, for a traditional Homeowners policy (HO3 or HO5) it could be 2% of the Dwelling coverage. If the Dwelling coverage is $200,000, the 2% Wind/Hail deductible will be $4,000. For a Condo (HO6) or a Renters (HO4) policy, the percentage is of the Personal Property (Contents) coverage. If the Personal Property coverage is $50,000, the 2% Wind/Hail deductible will be $1,000.\n \n Example: A traditional Homeowners policy (HO3 or HO5) with $200,000 in Dwelling coverage has a deductible is 2%. There is a Windstorm or Hail claim for $20,000.The deductible is 2% of the $200,000 coverage = $4,000. Therefore the amount of the claim settlement will be $16,000."
          },
          mold_fungus: {
            title: "Mold, Fungus, Rot Damage",
            text: "This optional endorsement covers certain mold, fungus or rot damage caused by sudden or accidental discharge of water or steam if the loss is not otherwise excluded, from a plumbing, heating, air conditioning, irrigation, automatic fire protective sprinkler system or household appliance. Coverage includes the cost of tearing out and replacing part of a building necessary to repair the system or appliance. We do not cover loss to the system or appliance from which this water or steam escaped or loss caused by continuous or repeated seepage. Earth movement is never covered under this policy, however caused. We cover ensuing loss caused by fire or explosion. Certain restrictions and exclusions apply."
          },
          business_property: {
            title: "Business Property",
            text: "This is a special limit of liability that applies to business property kept at the home. Examples of business property are: photography equipment used primarily by the insured in a part or full time business. Lawn/landscaping equipment used primarily for business. Tools used primarily in the insured's trade or business such as: mechanic, carpenter, contractor, etc. Certain restrictions and exclusions apply."
          },
          personal_injury: {
            title: "Personal Injury",
            text: "This optional endorsement extends the Liability coverage (E) to include mental or psychological injury or damages, particularly as a result of slander, defamation, false arrest or imprisonment, or malicious prosecution. It does not increase the amount of coverage, just the types of occurrences that may be covered, and it does not include coverage for physical injury, like an accident. Certain restrictions and exclusions apply."
          },
          home_cyberbase: {
            title: "Home Cyber Base",
            text: "Home Cyber Protection coverage is composed of the 3 ''Core'' components of Cyber Attack, Cyber Extortion and Online Fraud at limits of either $25,000 or $50,000 with a $500 deductible. For an additional charge, the Core components can be expanded to include coverage for Data Breach or Data Breach and Cyber Bullying:\n \n Cyber Attack - Pays for the costs of restoring data and systems of Computing Devices and Connected Home Devices following an unauthorized use or access, or the perpetration of a malware attack. \n \n Cyber Extortion - Provides professional assistance from a subject matter expert and payments with prior approval in response to a demand for money or other consideration coupled with a threat to damage, disable, deny access or disseminate content from your device, system or data or an offer to restore access or functionality in connection with an attack on your device, system or data that has already occurred.\n \n Online Fraud- Pays for the amount fraudulently taken from an insured following:\n ◦An identity theft;\n ◦The unauthorized use of a bank card or credit card;\n ◦The forgery or alteration of any check or negotiable instrument;\n ◦Acceptance in good faith of counterfeit currency; or\n ◦An intentional and criminal deception to induce the insured to part voluntarily with something of value.\n \n The online fraud must be wholly or partially perpetrated through a computing device or connected home device."
          },
          hcbpackage_databreach: {
            title: "Home Cyber Base Package + Data Breach",
            text: "Home Cyber Protection coverage is composed of the 3 ''Core'' components of Cyber Attack, Cyber Extortion and Online Fraud at limits of either $25,000 or $50,000 with a $500 deductible. For an additional charge, the Core components can be expanded to include coverage for Data Breach or Data Breach and Cyber Bullying:\n \n Cyber Attack - Pays for the costs of restoring data and systems of Computing Devices and Connected Home Devices following an unauthorized use or access, or the perpetration of a malware attack.\n \n Cyber Extortion - Provides professional assistance from a subject matter expert and payments with prior approval in response to a demand for money or other consideration coupled with a threat to damage, disable, deny access or disseminate content from your device, system or data or an offer to restore access or functionality in connection with an attack on your device, system or data that has already occurred.\n \n Online Fraud- Pays for the amount fraudulently taken from an insured following:\n ◦An identity theft;\n ◦The unauthorized use of a bank card or credit card;\n ◦The forgery or alteration of any check or negotiable instrument;\n ◦Acceptance in good faith of counterfeit currency; or\n ◦An intentional and criminal deception to induce the insured to part voluntarily with something of value.\n \n The online fraud must be wholly or partially perpetrated through a computing device or connected home device.\n \n Data Breach - Pays for costs for an individual to respond to the loss, theft, accidental release or accidental publication of personally identifying information or personally sensitive information in which you are entrusted. The costs incurred include Forensic IT and Legal Review, the Costs to Notify Affected Individuals as well as the costs of Services to Affected Individuals."
          },
          hcbbreach_bullying: {
            title: "Home Cyber Base Package + Data Breach + Cyber Bullying",
            text: "Home Cyber Protection coverage is composed of the 3 ''Core'' components of Cyber Attack, Cyber Extortion and Online Fraud at limits of either $25,000 or $50,000 with a $500 deductible. For an additional charge, the Core components can be expanded to include coverage for Data Breach or Data Breach and Cyber Bullying:\n \n Cyber Attack - Pays for the costs of restoring data and systems of Computing Devices and Connected Home Devices following an unauthorized use or access, or the perpetration of a malware attack.\n \n Cyber Extortion - Provides professional assistance from a subject matter expert and payments with prior approval in response to a demand for money or other consideration coupled with a threat to damage, disable, deny access or disseminate content from your device, system or data or an offer to restore access or functionality in connection with an attack on your device, system or data that has already occurred. \n \n Online Fraud- Pays for the amount fraudulently taken from an insured following:\n ◦An identity theft;\n ◦The unauthorized use of a bank card or credit card;\n ◦The forgery or alteration of any check or negotiable instrument;\n ◦Acceptance in good faith of counterfeit currency; or\n ◦An intentional and criminal deception to induce the insured to part voluntarily with something of value.\n \n The online fraud must be wholly or partially perpetrated through a computing device or connected home device.\n \n Data Breach - Pays for costs for an individual to respond to the loss, theft, accidental release or accidental publication of personally identifying information or personally sensitive information in which you are entrusted. The costs incurred include Forensic IT and Legal Review, the Costs to Notify Affected Individuals as well as the costs of Services to Affected Individuals.\n \n Cyberbullying - Pays for the costs an individual may incur being the victim of a cyberbullying attack. These costs can include: psychiatric counseling services; legal expenses; temporary relocation expenses; temporary private tutoring and enrollment expenses; professional cybersecurity consultation services; social monitoring software and web-based products to prevent further bullying."
          },
          spp: {
            title: "Special Personal Property",
            text: "The Special Personal Property Coverage endorsement increases the Special Limits of Liability for Personal Property Items."
          },
          earthquake: {
            title: "Earthquake",
            text: "This optional endorsement covers direct physical loss to property covered under Section I of the policy (Property Coverages) caused by earthquake, including land shock waves or tremors before, during or after a volcanic eruption. One or more earthquake shocks that occur within a 72-hour period constitute a single earthquake. This coverage does not increase the limits of liability stated in this policy. Certain restrictions and exclusions apply."
          },
          hurricane: {
            title: "Hurricane Deductible",
            text: ""
          },
          roof_Damage_WindHail: {
            title: "Roof Damage - Wind/Hail",
            text: "This coverage pertains to the loss settlement provision related to damage to the roof surfacing due to the peril of windstorm or hail. The loss settlement provision can be on either an Actual Cash Value (ACV) or Replacement Cost basis. The selection of COVERAGE reflects the ACV option while the selection of N/A reflects the Replacement Cost option."
          },
          foundation_coverage: {
            title: "Foundation Coverage",
            text: "This endorsement provides coverage for settling, cracking, shrinking, bulging, or expansion of foundations, floor slab or footings that support the dwelling when caused by seepage or leakage of water or steam from within a plumbing, heating, air conditioning or automatic fire protection sprinkler system. The coverage is limited to 15% of the amount of insurance for Coverage A - Dwelling. Certain restrictions apply."
          },
          limited_hurricane: {
            title: "Limited Hurricane Coverage",
            text: "This optional endorsement covers direct physical loss to property covered under Section I of the policy (Property Coverages) caused by earthquake, including land shock waves or tremors before, during or after a volcanic eruption. One or more earthquake shocks that occur within a 72-hour period constitute a single earthquake. This coverage does not increase the limits of liability stated in this policy. Certain restrictions and exclusions apply."
          },
          mineSubsidence: {
            title: "Mine Subsidence",
            text: "The basic homeowners policy excludes earth movement and therefore does not cover mine subsidence claims, This optional endorsement helps cover direct loss to residences caused by mine subsidence"
          }
        };
        return e[l] ? e[l] : {
          title: "",
          text: ""
        };
      }
    }, {
      key: "getTodayDate",
      value: function () {
        var l = new Date(),
          e = "" + (l.getMonth() + 1),
          n = "" + l.getDate(),
          u = l.getFullYear();
        return e.length < 2 && (e = "0" + e), n.length < 2 && (n = "0" + n), [u, e, n].join("-");
      }
    }, {
      key: "formatDate",
      value: function (l) {
        var e = new Date(l),
          n = "" + (e.getMonth() + 1),
          u = "" + e.getDate(),
          t = e.getFullYear();
        return n.length < 2 && (n = "0" + n), u.length < 2 && (u = "0" + u), [t, n, u].join("-");
      }
    }, {
      key: "dateAfterOneYear",
      value: function (l) {
        var e = new Date(l),
          n = new Date(e.setFullYear(e.getFullYear() + 1)),
          u = "" + (n.getMonth() + 1),
          t = "" + n.getDate(),
          o = n.getFullYear();
        return u.length < 2 && (u = "0" + u), t.length < 2 && (t = "0" + t), [o, u, t].join("-");
      }
    }, {
      key: "getAge",
      value: function (l) {
        var e = new Date(),
          n = new Date(l);
        return e.getFullYear() - n.getFullYear();
      }
    }, {
      key: "numberWithCommas",
      value: function (l) {
        return l.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }, {
      key: "getMonthlyPremiums",
      value: function (l) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "m",
          n = Number(l.replace(/[^0-9.-]+/g, ""));
        if (console.log("yearlyPremium", n), "m" == e) {
          var u = (n / 12).toFixed(2);
          return console.log("monthlyPremium", u), u = this.numberWithCommas(u);
        }
        return this.numberWithCommas(n);
      }
    }, {
      key: "getCoverageConfigBo",
      value: (l = _asyncToGenerator(_regeneratorRuntime.mark(function l(e, n, u, t, o) {
        var a, r, i, s, c;
        return _regeneratorRuntime.wrap(function (l) {
          for (;;) switch (l.prev = l.next) {
            case 0:
              return a = {
                env: "PROD",
                state: e,
                plan: u,
                home_type: n,
                lob: "home",
                carrier: "sw",
                status: 1
              }, r = {}, l.next = 4, backendService.getCarrierConfigBo(a);
            case 4:
              if ("Success" != (i = l.sent).message) {
                l.next = 15;
                break;
              }
              for (i = i.data, s = 0; s < i.count; s++) "true" == (c = i.data[s]).coverage_val ? c.coverage_val = !0 : "false" == c.coverage_val ? c.coverage_val = !1 : "[" == c.coverage_val.trim()[0] ? c.coverage_val = JSON.parse(c.coverage_val) : c.coverage_val = 0 == c.coverage_val ? null : (+c.coverage_val).toString() === c.coverage_val ? +c.coverage_val : c.coverage_val, r[c.coverage_name] = c.coverage_val;
              return r.state = e, r.homeType = n, r.planType = u, r.yearBuilt = t, r.brushForestError = o, console.log(r), l.abrupt("return", r);
            case 15:
            case "end":
              return l.stop();
          }
        }, l);
      })), function (e, n, u, t, o) {
        return l.apply(this, arguments);
      })
    }]);
    var l, e, n, u, t, o, a, r;
  }();
module.exports = {
  StillWaterHelper: StillWaterHelper
};